// console.log('i loads'); 
var transitionDuration = 300;
var canCheckout = false;
if (localStorage.getItem("ecw_override_can_checkout")) {
  canCheckout = true;
  localStorage.removeItem("ecw_override_can_checkout");
}
var checkoutFrame = {};
var userHasSearched = false;

var $contentContainer = jQuery(".wf-ordering-container");
var templateRoot = "/wp-content/themes/wildfire/parts/block/templates/";

var phonesMasks = [
  { mask: "(###) ###-####" },
];
var dateMasks = [{ mask: "##/##" }];
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
// Document Ready Actions
jQuery(document).ready(function ($) {

  //single use button util 
  $('button[showsingleuseproducts]').click(function () {
    change_view("menu");
    localStorage.setItem('readOnlyCategoryMenuItemCarryOver', 'CHOOSE FROM THE FOLLOWING:');
  });
  $('a#basket').click(function () {
    // view_cart();
    // console.log('view basket');
    updateBasketDisplay(openBasket = true);
    change_view('cart');
  });


  // $("#rewards-signup").click(displaySignUpForm);

  // console.log('doc loaded', $("[data-add-another-menu-item]"));
  //

  //
  $("a[data-header-account-link]").click(function (e) {
    e.preventDefault();
    // if ($("#shopping-cart-view").is(":visible")) {
    //   // console.log('not view cart!');
    //   console.log('not view cart!');

    //   not_view_cart();
    // }
    if ($("#product-detail-view").is(":visible")) {
      // $("#product-detail-view").foundation("close");
      $(".reveal-overlay").removeClass('differnt-popup-overlay');
    }
    var accountNavDropdown = $(this).attr("data-toggle");
    if (isUserLoggedIn(true)) {
      // console.log("user is logged in");
      $("#" + accountNavDropdown).removeClass("hide");
      $('.signInButton').addClass("hide");
      $('.accountButton').removeClass("hide");
      // console.log(accountNavDropdown);
      // $('#'+accountNavDropdown).foundation('toggle');
    } else {
      // console.log("user is NOT logged in");
      // accountNavDropdown.addClass('hide');
      $("#" + accountNavDropdown).addClass("hide");
      $('.signInButton').removeClass("hide");
      $('.accountButton').addClass("hide");

      window.location.href = $(this).attr("href");
    }
  });
  if (isUserLoggedIn(true)) {
    // console.log('#1');
    $('.accountButton').removeClass("hide");
    $('.signInButton').addClass("hide");
  } else {
    // console.log('#2');
    $('.accountButton').addClass("hide");
    $('.signInButton').removeClass("hide");
  }
  if ($('.location-map').length || $(".wf-ordering").length) {
    $("[data-header-order-link]").addClass("hide");
    $("[data-header-ecomm-link]").removeClass("hide");
  } else {
    $("[data-header-order-link]").removeClass("hide");
    $("[data-header-ecomm-link]").addClass("hide");
  }
  if ($(".wf-ordering").length) {
    // if the page is visited with a store id in tow, set the store to the customer's store as their entry point was likely from an "order now" link
    if (
      urlParam("storeid") &&
      (urlParam("storeid") !==
        localStorage.getItem("ecw_visitor_nearest_location_id") ||
        urlParam("storeid") !==
        localStorage.getItem("ecw_customer_store_location_id"))
    ) {
      ecw_show_overloading();
      console.log('-- Set Store --');

      setAsStore(urlParam("storeid"));

      setTimeout(function () {
        var hash = $(location).attr("hash");
        history.replaceState &&
          history.replaceState(
            null,
            "",
            location.pathname +
            location.search
              .replace(/[\?&]storeid=[^&]+/, "")
              .replace(/^&/, "?") +
            hash
          );
        // console.log('-- RELOAD --');
        location.reload();
      }, 750);
    }

    ecw_get_route();
    // console.log('update basket test #5');
    if (window.location.href.includes('cart') && localStorage.getItem("ecw_customer_basket_id") && localStorage.getItem("ecw_customer_store_location_id")) {
      updateBasketDisplay(openBasket = true);

    } else {
      updateBasketDisplay();
    }

    // // De-sticky to the top navigation
    // if ($("header.header").length) {
    //   $("header.header").foundation("_destroy");
    // }



    // $('#continue-as-guest').click(function (e) {
    //   e.preventDefault();
    // });

    // $(".cart-favorite-button").click(function () {
    //   $(".cart-favorite-order").foundation("open");
    // });

    // $(".cart-confirm-favorite-button").click(function () {
    //   $.ajax({
    //     type: "POST",
    //     url: ajax_url,
    //     data: {
    //       action: "olo_set_fave",
    //       authtoken: localStorage.getItem("ecw_auth_token"),
    //       basketid: localStorage.getItem("ecw_customer_basket_id"),
    //       description: $("[data-cart-favorite-order-description]").val(),
    //     },
    //     success: function (response) {
    //       fave_result = JSON.parse(response);

    //       if (fave_result.code == 200) {
    //         alert(fave_result.message);
    //         $(".cart-favorite-order").foundation("open");
    //       } else if (fave_result.faves[0].id) {
    //         $("[data-fave-id]").text(fave_result.faves[0].id);

    //         $(".cart-favorite-button").addClass("location-favorite-active");
    //       }
    //     },
    //   });
    // });

    // Remove reveal modal
    $(".cart-favorite-order").each(function () {
      if (typeof $(this).attr("aria-hidden") !== "undefined") {
        $(this).parent().remove();
      }
    });

    // Recreate reveal modals
    var $favorite_reveal = new Foundation.Reveal($("#cart-favorite-order"), {});

    // $("input#guest-phone-number").keyup(function() {
    //   $(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d+)$/, "($1)$2-$3"));
    // });
    $("input#guest-phone-number").inputmask({
      mask: phonesMasks,
      greedy: false,
      definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
    });

    // // Reload upsell items on cart open
    // $("#shopping-cart-view").on("open.zf.reveal", function () {
    // if ($("#cart-upsell-items-list").length) {
    //   $("#cart-upsell-items-list").slick("refresh");
    // }
    // $(".reveal-overlay").addClass('differnt-popup-overlay');
    // });
  }

  //when [data-add-another-menu-item] button is clicked, load wf-ordering-menu template into view
  $("[data-add-another-menu-item]").click(function () {
    change_view("menu");
  });
  $("ul.menu li.specific-menu").click(function () {
    // console.log('ahh');
    change_view("menu");
  });

  //when .edit-button clicked, load .wf-ordering-start-order template
  $("[data-edit-location-button]").click(function () {
    // change_view("start-order");
    // $("#shopping-cart-view").foundation("close");
    $("#checkout-edit-store-location").foundation("open");
    $(".reveal-overlay").removeClass('differnt-popup-overlay');
  });

  // Change store location form action
  $("#change-store-location").click(function () {
    change_view("start-order");
  });

  // Change order type
  $("#change-order-type").click(function () {
    change_view("start-order");
  });
});

jQuery(window).on("hashchange", function (e) {
  if (jQuery(".wf-ordering").length) {
    // console.log("hashchange");
    ecw_get_route();
    // updateBasketDisplay();
    window.scrollTo(0, 0);
  }
});

// Changes the current view
function change_view(hash, noHashChange) {
  // console.log("change view: ", hash);
  var $ = jQuery;

  // if (hash === 'start-order') {
  //   if (window.location.pathname !== '/locations/') {
  //     window.location.href = "/locations/";
  //   }
  // } else  
  if (noHashChange && hash) {
    history.pushState(null, null, "#" + hash);
  } else if (window.location.href.indexOf("/order") > -1) {
    // console.log('hash change');
    history.pushState(null, null, "#" + hash);
    $(window).trigger("hashchange");
  } else {
    window.location.href = "/order/#" + hash;
  }

  if (hash) {
    // console.log('sdghasdg');
    $('.homepage-order-status.order-tracker').addClass('noShow');
  } else {
    const currentPath = window.location.pathname;
    // console.log('asdghasdg', currentPath);
    $('.homepage-order-status.order-tracker').removeClass('noShow');
  }
} // change_view

// Routes view dependent on the url hash
function ecw_get_route() {
  // console.log("routing");
  var route = "";
  var $ = jQuery;

  if (window.location.hash) {
    route = window.location.hash.substr(1);
  }
  route = route.split("_")[0];

  ecw_show_topnav();
  ecw_show_topnav_location();
  if (window.location.href.includes("code=")) {
    console.log('url param');
    ecw_show_overloading();

    const url = new URL(window.location.href);

    let auth_grant = null;

    const match = decodeURIComponent(window.location.href).match(/code=([^&]+)/);
    if (match) {
      auth_grant = match[1];
    }

    // console.log("auth token:", authToken);
    olo_authenticate_with_auth_token(auth_grant);
  }
  if (route.includes("group-order/join")) {
    view_join_group_order();
  } else if (route.includes("menu-category")) {
    ecw_show_overloading();
    view_menu();
    let categoryNumber = route.match(/\d+/);
    if (categoryNumber) {
      setTimeout(function () {
        let inputBox = $('button#' + categoryNumber);
        // let radioButton = $(`select#category-dropdown option#${categoryNumber}`);
        // console.log('radioButton', categoryNumber);
        // console.log('radioButton', inputBox);
        if (inputBox.length) {
          inputBox.prop('checked', true); // check the input
          onCategoryChange(inputBox);
          ecw_hide_overloading();
        } else {
          change_view('menu', noHashChange = true);
          ecw_hide_overloading();
        }
      }, 1800);

    } else {
      change_view('menu', noHashChange = true);
      ecw_hide_overloading();
    }
  } else if (route.includes("menu-product")) {
    ecw_show_overloading();
    view_menu();
    let menuProductNumber = route.match(/\d+/);
    if (menuProductNumber) {
      // console.log('menuProductNumber', menuProductNumber);
      setTimeout(function () {
        let $menuProductItemButton = $('button[data-menu-selection-id="' + menuProductNumber + '"]');

        if ($menuProductItemButton.length) {
          $menuProductItemButton.trigger('click'); // or $menuItem.click();
          ecw_hide_overloading();
        } else {
          change_view('menu', noHashChange = true);
          ecw_hide_overloading();
        }
      }, 1800);
    } else {
      change_view('menu', noHashChange = true);
      ecw_hide_overloading();

    }
  } else {
    $contentContainer.empty();

    switch (route) {
      case "group-order-login":
        // signout();
        view_group_login();
        break;
      case "menu":
      case "menu-product-view":
        view_menu();
        break; // end view-menu
      case "cart":
        // console.log('show cart');
        view_menu(openCart = true);
        // view_cart();
        break;

      case "checkout":
        view_checkout();
        break;
      case "register-card":
        view_register_card();
        break;
      case "order-status":
      case "order-complete":
        view_order_complete();
        break;


      case "signup":
        view_signup();
        break; // end signup

      case "login":
        view_login();
        break; // end login


      case "forgotpass":
        // console.log("forgotpass");
        view_forgotpassword();
        break;

      case "signout":
        view_signout();
        break; // end signout
      case "guest-checkout":
        view_guest_login();
        break;
      case "account":
        if (isUserLoggedIn()) {
          view_account();
        } else {
          change_view("login");
        }
        break; // end my-account

      case "account-manage":
        if (isUserLoggedIn()) {
          view_account_manage();
        } else {
          change_view("login");
        }
        break; // end my-account

      case "account-recent":
        if (isUserLoggedIn()) {
          view_account_recent();
        } else {
          change_view("login");
        }
        break;

      case "account-favorite":
        if (isUserLoggedIn()) {
          view_account_favorite();
        } else {
          change_view("login");
        }
        break;

      case "account-rewards":
        if (isUserLoggedIn()) {
          view_account_rewards();
        } else {
          change_view("login");
        }
        break;

      // case "location-detail":
      //   view_location_detail();
      //   break;

      case "":
      case "home":
      case "find-store":
      case "start-order":
      case "menu-item":
      default:
        view_start_order();
        break;
      // view_home();
      // break; // end '', 'home', default
    } // end Switch (template routing & actions)
  }

}

// check if auth token is still valid
function isUserLoggedIn(softCheck = false) {
  var $ = jQuery;

  // console.log("check user statuss");

  // Just look for the stored auth token, no need to query OLO to validate
  if (softCheck) {
    return Boolean(localStorage.getItem("ecw_auth_token"));
  }

  if (localStorage.getItem("ecw_auth_token")) {
    var isLoggedIn = false;

    return $.ajax({
      type: 'POST',
      url: ajax_url,
      async: false,
      data: {
        action: 'olo_user_authtoken_status',
        authtoken: localStorage.getItem('ecw_auth_token'),
        referer: window.location.href

      },
      success: function (response) {
        isLoggedIn = (response === "true");
        if (!isLoggedIn) {
          signout();
        }
        return isLoggedIn;
      }
    });

    return isLoggedIn;

  } else {
    // console.log('#3');
    $('.accountButton').addClass("hide");
    $('.signInButton').removeClass("hide");
    return false;
  }

}

// function populate_user_restaurants(view_context) {
//   var $ = jQuery;

//   console.log("populate user restaurants", view_context);

//   var restaurants = [];
//   var location_count = 0;
//   var locations_processed = 0;

//   // if user navigated from location page, display the location selected there
//   if (
//     localStorage.getItem("ecw_location_page_location_id") &&
//     !localStorage.getItem("ecw_location_page_location_id").includes("wp_")
//   ) {
//     location_count++;
//     // set selected
//     $.ajax({
//       type: "POST",
//       url: ajax_url,
//       data: {
//         action: "olo_get_restaurant",
//         restaurant_id: localStorage.getItem(
//           "ecw_location_page_location_id"
//         ),
//         get_calendar: true,
//       },
//       success: function (response, view_context) {
//         var result = JSON.parse(response);
//         // console.log("populate_user_restaurants 1", result);
//         if (result.id) {
//           restaurants.push(result);
//           locations_processed++;
//         }

//         if (locations_processed >= location_count) {
//           set_location_selections(restaurants, view_context);
//         }
//       },
//     });
//   }

//   // If there's already a selected location, display it
//   if (
//     localStorage.getItem("ecw_customer_store_location_id") &&
//     !localStorage.getItem("ecw_customer_store_location_id").includes("wp_")
//   ) {
//     location_count++;

//     // Function to fetch restaurant info by ID
//     function fetchRestaurantInfo(restaurantId) {
//       return $.ajax({
//         type: "POST",
//         url: ajax_url,
//         data: {
//           action: "olo_get_restaurant",
//           restaurant_id: restaurantId,
//           get_calendar: true,
//         }
//       }).then(response => {
//         var result = JSON.parse(response);
//         // console.log("Restaurant info for ID", restaurantId, result);
//         return result;
//       }).catch(() => {
//         console.error("Failed to fetch restaurant info for ID", restaurantId);
//         return null;
//       });
//     }

//     // Function to process all restaurants
//     function processRestaurants(restaurantIds) {
//       var restaurants = [];
//       var locations_processed = 0;
//       var location_count = restaurantIds.length; // Number of locations to process

//       // Fetch info for each restaurant
//       var fetchPromises = restaurantIds.map(restaurantId => fetchRestaurantInfo(restaurantId));

//       // Wait for all AJAX calls to complete
//       $.when.apply($, fetchPromises).then(function () {
//         var results = Array.prototype.slice.call(arguments);

//         results.forEach(result => {
//           if (result && result.id) {
//             // Make sure this restaurant isn't already in the list
//             var exists = restaurants.some(restaurant => result.id == restaurant.id);

//             if (!exists) {
//               restaurants.push(result);
//             }
//             locations_processed++;
//           }
//         });

//         // Check if all locations have been processed
//         if (locations_processed >= location_count) {
//           set_location_selections(restaurants);
//         }
//       });
//     }

//     // Get the customer store location ID and ensure it is processed first
//     var customerStoreId = localStorage.getItem("ecw_customer_store_location_id");

//     if (customerStoreId) {
//       fetchRestaurantInfo(customerStoreId).then(result => {
//         var restaurantIds = [
//           customerStoreId,
//           localStorage.getItem("nearByStore1"),
//           localStorage.getItem("nearByStore2"),
//           localStorage.getItem("nearByStore3")
//         ].filter(Boolean); // Remove null or empty values

//         processRestaurants(restaurantIds);
//       });
//     }
//   }


//   // If the user has favorite location(s), display them
//   if (localStorage.getItem("ecw_auth_token")) {
//     $.ajax({
//       type: "POST",
//       url: ajax_url,
//       data: {
//         action: "olo_get_fave_locations",
//         authtoken: localStorage.getItem("ecw_auth_token"),
//       },
//       success: function (response) {
//         result = JSON.parse(response);

//         // console.log(Boolean(result.favelocations));

//         if (result.favelocations && result.favelocations.length) {
//           location_count = location_count + result.favelocations.length;

//           result.favelocations.forEach(function (fave) {
//             $.ajax({
//               type: "POST",
//               url: ajax_url,
//               data: {
//                 action: "olo_get_restaurant",
//                 restaurant_id: fave.vendorid,
//                 get_calendar: true,
//               },
//               success: function (response) {
//                 var result = JSON.parse(response);
//                 // console.log(
//                 //   "populate_user_restaurants 3 fav locations",
//                 //   result
//                 // );
//                 if (result.id) {
//                   // make sure this restaurant isn't already in the list
//                   var exists = false;
//                   restaurants.forEach(function (restaurant) {
//                     if (result.id == restaurant.id) {
//                       exists = true;
//                     }
//                   });

//                   if (!exists) {
//                     restaurants.push(result);
//                   }

//                   locations_processed++;
//                 }

//                 if (locations_processed >= location_count) {
//                   set_location_selections(restaurants, view_context);
//                   ecw_hide_loading();
//                 }
//               },
//             });
//           });
//         } else {
//           if (locations_processed >= location_count) {
//             set_location_selections(restaurants, view_context);
//             ecw_hide_loading();
//           }
//         }
//       },
//     });
//   } else {
//     if (locations_processed >= location_count) {
//       set_location_selections(restaurants, view_context);
//       ecw_hide_loading();
//     }
//   }
//   //add functionality for map overlay
//   function hideOverlay() {
//     const overlay = document.querySelector('.location-map-overlay');
//     // console.log("Overlay element:", overlay);

//     if (overlay) {
//       // console.log("Overlay found, setting timeout");
//       setTimeout(() => {
//         overlay.classList.add('hide');
//         // console.log("Class 'hide' added to overlay");
//       }, 5000);
//     } else {
//       // console.log("Overlay not found");
//     }
//   }
//   // Hide overlay after 5 seconds
//   hideOverlay();

//   // Add event listener for the close button
//   const closeButton = document.getElementById('closeMapOverlay');
//   if (closeButton) {
//     closeButton.addEventListener('click', function () {
//       const overlay = document.querySelector('.location-map-overlay');
//       if (overlay) {
//         overlay.classList.add('hide');
//         // console.log("Class 'hide' added to overlay via button click");
//       }
//     });
//   }

//   // Add event listener for the search field
//   const startOrderInput = document.getElementById('start-order-order-location-search');
//   if (startOrderInput) {
//     startOrderInput.addEventListener('click', function () {
//       const overlay = document.querySelector('.location-map-overlay');
//       if (overlay) {
//         overlay.classList.add('hide');
//         // console.log("Class 'hide' added to overlay via input click");
//       }
//     });
//   }

// } // populate_user_restaurants(view_context)

// Move payment method to active state for checkout
function usePayment(billingAccountId) {
  var $ = jQuery;

  // console.log("use payment");

  $("[data-billing-schemes-active]").append(
    $("#billing-account-" + billingAccountId)
  );

  configPaymentOptions();
}

// Remove payment method from active state for checkout
function removePayment(billingAccountId) {
  var $ = jQuery;

  // console.log("remove payment");

  $("[data-billing-accounts-saved]").append(
    $("#billing-account-" + billingAccountId)
  );

  configPaymentOptions();
}

// Configure payment options
function configPaymentOptions() {
  var $ = jQuery;

  var activeCount = $(
    "[data-billing-schemes-active] .active-payment:not(.hide)"
  ).length;

  if (activeCount > 0) {
    $("[data-billing-accounts-saved] .active-payment:not(.hide)").each(
      function () {
        // console.log('$(this)', $(this));
        $(this).find("[data-split]").removeClass("hide");
        $(this).find("[data-use]").addClass("hide");
      }
    );
    $("[data-no-payments]").addClass("hide");
  } else {
    $("[data-billing-accounts-saved] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split]").addClass("hide");
        $(this).find("[data-use]").removeClass("hide").text('USE').removeClass('applied');
      }
    );
    $("[data-no-payments]").removeClass("hide");
  }

  if ($("[data-billing-accounts-saved] .active-payment:not(.hide)").length) {
    $("#stored-payments").removeClass("hide");
  } else {
    $("#stored-payments").addClass("hide");
  }
  setPaymentSplit();
}

// View: Home
// function view_home() {
//   var $ = jQuery;

//   ecw_show_topnav();
//   ecw_hide_topnav_location();

//   // TODO: include modifier costs in prices of order items

//   $contentContainer
//     .load(templateRoot + "wf-ordering-home.html", function () {
//       ecw_show_loading();

//       // Remove reveal modal
//       $(
//         "#account-select-order-type, #home-select-order-type",
//         "#menu-select-order-type",
//         "#location-detail-select-order-type"
//       ).each(function () {
//         if (typeof $(this).attr("aria-hidden") !== "undefined") {
//           $(this).parent().remove();
//         }
//       });

//       // Recreate reveal modals
//       var $select_order_type_reveal = new Foundation.Reveal(
//         $("#home-select-order-type"),
//         {}
//       );

//       // Remove reveal modal
//       $(".home-add-favorite-order").each(function () {
//         if (typeof $(this).attr("aria-hidden") !== "undefined") {
//           $(this).parent().remove();
//         }
//       });

//       $(".home-delete-favorite-order").each(function () {
//         if (typeof $(this).attr("aria-hidden") !== "undefined") {
//           $(this).parent().remove();
//         }
//       });

//       // Recreate reveal modals
//       var $add_favorite_reveal = new Foundation.Reveal(
//         $("#home-add-favorite-order"),
//         {}
//       );
//       var $delete_favorite_reveal = new Foundation.Reveal(
//         $("#home-delete-favorite-order"),
//         {}
//       );

//       $("#home-select-order-type-button").click(function () {
//         if ($(".data-order-type-recent-id").text() !== "") {
//           startRecentOrder($(".data-order-type-recent-id").text(), "home");
//         }

//         if ($(".data-order-type-fave-id").text() !== "") {
//           startFavoriteOrder($(".data-order-type-fave-id").text(), "home");
//         }

//         if ($('.data-order-type-location-id:first').text() !== "") {
//           startReferralOrder($('.data-order-type-location-id:first').text(), $('.data-order-type-location-sbt:first').text(), 'home');
//         }
//       });

//       // Hide/show schedule elements
//       $('input[name="home-order-schedule"]').change(function () {
//         if ($('input[name="home-order-schedule"]:checked').val() == "advance") {
//           $("#home-schedule-time").removeClass("hide");
//         } else {
//           $("#home-schedule-time").addClass("hide");
//         }
//         // console.log($('input[name="order-schedule"]:checked').val());
//       });

//       var todaysDate = new Date();
//       var tomorrowsDate = new Date().addDays(1);
//       var scheduleDates = getDates(todaysDate, new Date().addDays(45));
//       var daysOfWeek = [
//         "Sunday",
//         "Monday",
//         "Tuesday",
//         "Wednesday",
//         "Thursday",
//         "Friday",
//         "Saturday",
//       ];

//       for (var i = 0; i < scheduleDates.length; i++) {
//         var dayValue =
//           scheduleDates[i].getFullYear() +
//           "-" +
//           zeroPad(scheduleDates[i].getMonth() + 1, 2) +
//           "-" +
//           zeroPad(scheduleDates[i].getDate(), 2);
//         var dayLabel =
//           daysOfWeek[scheduleDates[i].getDay()] +
//           " " +
//           (scheduleDates[i].getMonth() + 1) +
//           "/" +
//           scheduleDates[i].getDate();

//         if (scheduleDates[i].getTime() === todaysDate.getTime()) {
//           dayLabel = "Today";
//         }
//         if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
//           dayLabel = "Tomorrow";
//         }

//         $("[data-home-order-time-wanted-day]").append(
//           '<option value="' + dayValue + '">' + dayLabel + "</option>"
//         );
//       }

//       var timeSelection = createQuarterHourIntervals();

//       for (var ii = 0; ii < timeSelection.length; ii++) {
//         $("[data-home-order-time-wanted-time]").append(
//           '<option value="' +
//           convert12to24Hour(timeSelection[ii]) +
//           '">' +
//           timeSelection[ii] +
//           "</option>"
//         );
//       }

//       $("select#home-time-wanted-day").change(function () {
//         if (
//           $(
//             'select#home-time-wanted-day option[value="' + $(this).val() + '"]'
//           ).text() == "Today"
//         ) {
//           var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
//           // console.log(currentTime);
//           $("select#home-time-wanted-time-slot option").each(function () {
//             if ($(this).val() < currentTime) {
//               $(this).addClass("hide");
//             }
//             $("select#home-time-wanted-time-slot").val(currentTime);
//           });
//         } else {
//           $("select#home-time-wanted-time-slot option").each(function () {
//             $(this).removeClass("hide");
//           });
//         }
//       });

//       $("select#home-time-wanted-day").trigger("change");

//       var totalLoadBeforeComplete = 2; // Will not remove loading overlay until all async elements have loaded

//       // Set Hero Section

//       var $sliderContainer = $("#order-hero-section");
//       $.each(heroSliderData, function (key, slider) {
//         var $sliderItem = $("[data-hero-item-template].hide").clone();

//         $sliderItem.css({
//           "background-image": "url(" + slider.background_image_url + ")",
//         });
//         $sliderItem
//           .find("[data-overlay-text]")
//           .html(decodeURIComponent(slider.overlay_text));

//         $sliderItem.removeClass("hide");
//         $sliderContainer.append($sliderItem);
//       });

//       $("[data-hero-item-template].hide").remove();

//       // if ($("#order-hero-section").length) {
//       //   $("#order-hero-section").slick({
//       //     slidesToShow: 1,
//       //     slidesToScroll: 1,
//       //     arrows: false,
//       //     dots: true,
//       //     autoplay: false,
//       //     // autoplaySpeed: 4000,
//       //   });
//       // }

//       // Retrieve Recent Orders
//       if (isUserLoggedIn()) {
//         $.ajax({
//           type: "POST",
//           url: ajax_url,
//           data: {
//             action: "olo_get_recent_orders",
//             authtoken: localStorage.getItem("ecw_auth_token"),
//           },
//           success: function (response) {
//             var results = JSON.parse(response);

//             if (results.orders !== undefined && results.orders.length > 0) {
//               totalLoadBeforeComplete++;

//               // cache menu for each restaurant
//               var menu_results_cache = {};

//               var order_locations = [];
//               results.orders.forEach(function (order) {
//                 if (
//                   !order_locations.length ||
//                   !order_locations.includes(order.vendorid)
//                 ) {
//                   order_locations.push(order.vendorid);
//                 }
//               });

//               var menus_cached = 0;
//               order_locations.forEach(function (order_location) {
//                 $.ajax({
//                   type: "POST",
//                   url: ajax_url,
//                   data: {
//                     action: "get_olo_get_menu",
//                     restaurant_id: order_location,
//                   },
//                   success: function (response) {
//                     menu_results_cache[order_location] = JSON.parse(response);
//                     menus_cached++;

//                     if (menus_cached == order_locations.length) {
//                       results.orders.forEach(function (order) {
//                         if (
//                           (order.status == "Completed" ||
//                             order.status == "In Progress" ||
//                             order.status == "Scheduled") &&
//                           order.products.length > 0
//                         ) {
//                           var $recent_order = $(
//                             "[data-recent-order-template].hide"
//                           ).clone();
//                           $recent_order
//                             .find("[data-recent-order-title]")
//                             .text(order.name);
//                           $recent_order
//                             .find("[data-recent-order-id]")
//                             .text(order.id);
//                           $recent_order.find(".recent-order-id").text(order.id);
//                           $recent_order
//                             .find("[data-recent-order-vendor-id]")
//                             .text(order.vendorid);
//                           $recent_order
//                             .find("[data-recent-order-vendor-name]")
//                             .text(order.vendorname);

//                           var formatted_date =
//                             order.timeplaced.substring(0, 4) +
//                             "-" +
//                             order.timeplaced.substring(4, 6) +
//                             "-" +
//                             order.timeplaced.substring(6, 8) +
//                             order.timeplaced.substring(8);
//                           $recent_order
//                             .find("[data-recent-order-date]")
//                             .text(formatted_date);
//                           $recent_order
//                             .find("[data-recent-order-status]")
//                             .text(order.status);

//                           var status_processed = order.status
//                             .toLowerCase()
//                             .replace(/ /g, "_");
//                           $recent_order
//                             .find("[data-status='" + status_processed + "']")
//                             .removeClass("hide");

//                           // get metadata about favorite menu items from associated restaurant menu
//                           var menu_results = menu_results_cache[order.vendorid];

//                           order.products.forEach(function (product) {
//                             var matched = false;
//                             var product_calories;
//                             var product_price;
//                             var product_image_filename;

//                             menu_results.categories.every(function (category) {
//                               category.products.every(function (cat_product) {
//                                 if (product.name == cat_product.name) {
//                                   product_calories = cat_product.basecalories;
//                                   // product_price = cat_product.cost;
//                                   product_image_path = menu_results.imagepath;
//                                   product_image_filename =
//                                     cat_product.imagefilename;
//                                   matched = true;
//                                 }
//                                 return !matched;
//                               });
//                               return !matched;
//                             });

//                             var $recent_item = $recent_order
//                               .find("[data-recent-order-item-template]")
//                               .clone();

//                             if (product_image_filename != null) {
//                               $recent_item
//                                 .find("img")
//                                 .attr(
//                                   "src",
//                                   product_image_path + product_image_filename
//                                 );
//                             } else {
//                               $recent_item
//                                 .find("img")
//                                 .attr(
//                                   "src",
//                                   "/wp-content/themes/wildfire/assets/images/ecw-product-placeholder.svg"
//                                 );
//                             }

//                             $recent_item
//                               .find("[data-recent-order-item-name]")
//                               .text(product.name);
//                             if (product_calories != null) {
//                               $recent_item
//                                 .find("[data-recent-order-item-calories]")
//                                 .text(product_calories + " Calories | ");
//                             }
//                             // $recent_item.find('[data-recent-order-item-price]').text(product_price);

//                             var choiceArray = [];
//                             product.choices.forEach(function (choice) {
//                               choiceArray.push(choice.name);
//                             });

//                             $recent_item.removeClass("hide");
//                             $recent_item
//                               .find("[data-recent-order-item-choices]")
//                               .text(choiceArray.join(", "));
//                             $recent_item.removeAttr(
//                               "data-recent-order-item-template"
//                             );
//                             $recent_order
//                               .find(".recent-order-items")
//                               .append($recent_item);
//                           });

//                           $recent_order.removeClass("hide");
//                           $("[data-recent-orders-list]").append($recent_order);

//                           $("[data-recent-orders-list]").removeClass("hide");
//                           $("[data-recent-orders-loading]").addClass("hide");

//                           $(".recent-order-place-button").click(function () {
//                             $(".data-order-type-fave-id").text("");
//                             $(".data-order-type-recent-id").text(
//                               $(this)
//                                 .closest(".recent-order")
//                                 .find("[data-recent-order-id]")
//                                 .text()
//                             );
//                             window.scrollTo(0, 0);
//                             $("#home-select-order-type").foundation("open");
//                           });
//                         }
//                       });

//                       $(".home-favorite-button").click(function () {
//                         if ($(this).hasClass("location-favorite-active")) {
//                           $(
//                             ".home-delete-favorite-order-favorite-order-id"
//                           ).text(
//                             $(this).parent().find(".favorite-order-id").text()
//                           );
//                           $("#home-delete-favorite-order").foundation("open");
//                         } else {
//                           $(".home-add-favorite-order-recent-order-id").text(
//                             $(this).parent().find(".recent-order-id").text()
//                           );
//                           $("#home-add-favorite-order").foundation("open");
//                         }
//                       });

//                       $(".home-confirm-add-favorite-button").click(function () {
//                         $.ajax({
//                           type: "POST",
//                           url: ajax_url,
//                           data: {
//                             action: "olo_create_basket_from_order",
//                             authtoken: localStorage.getItem(
//                               "ecw_auth_token"
//                             ),
//                             orderid: $(
//                               ".home-add-favorite-order-recent-order-id"
//                             ).text(),
//                           },
//                           success: function (response) {
//                             result = JSON.parse(response);
//                             // console.log(response);
//                             // console.log(result);

//                             $.ajax({
//                               type: "POST",
//                               url: ajax_url,
//                               data: {
//                                 action: "olo_set_fave",
//                                 authtoken: localStorage.getItem(
//                                   "ecw_auth_token"
//                                 ),
//                                 basketid: result.id,
//                                 description: $(
//                                   "[data-favorite-order-description]"
//                                 ).val(),
//                               },
//                               success: function (response) {
//                                 fave_result = JSON.parse(response);

//                                 if (fave_result.code == 200) {
//                                   alert(fave_result.message);
//                                   $(".home-add-favorite-order").foundation(
//                                     "open"
//                                   );
//                                 } else if (fave_result.faves[0].id) {
//                                   window.location.reload();
//                                 }
//                               },
//                             });
//                           },
//                         });
//                       });

//                       $(".home-confirm-delete-favorite-button").click(
//                         function () {
//                           $.ajax({
//                             type: "POST",
//                             url: ajax_url,
//                             data: {
//                               action: "olo_delete_fave",
//                               authtoken: localStorage.getItem(
//                                 "ecw_auth_token"
//                               ),
//                               faveid: $(
//                                 ".home-delete-favorite-order-favorite-order-id"
//                               ).text(),
//                             },
//                             success: function (response) {
//                               window.location.reload();
//                             },
//                           });
//                         }
//                       );

//                       totalLoadBeforeComplete--;
//                       if (totalLoadBeforeComplete == 0) {
//                         ecw_hide_loading();
//                       }
//                     }
//                   },
//                   complete: function () {
//                     totalLoadBeforeComplete--;
//                     if (totalLoadBeforeComplete == 0) {
//                       ecw_hide_loading();
//                     }
//                   },
//                 });
//               });
//             } else {
//               $("[data-recent-orders-loading]").addClass("hide");
//               $("[data-recent-orders-not-found]").removeClass("hide");
//             }
//           },
//           complete: function () {
//             totalLoadBeforeComplete--;
//             if (totalLoadBeforeComplete == 0) {
//               ecw_hide_loading();
//             }
//           },
//         });
//       }

//       // Retrieve favorite orders
//       // console.log("Retrieve favorite orders");
//       if (isUserLoggedIn()) {
//         $.ajax({
//           type: "POST",
//           url: ajax_url,
//           data: {
//             action: "olo_get_faves",
//             authtoken: localStorage.getItem("ecw_auth_token"),
//           },
//           success: function (response) {
//             var results = JSON.parse(response);

//             if (results.faves !== undefined && results.faves.length > 0) {
//               totalLoadBeforeComplete++;

//               // cache menu for each restaurant
//               var menu_results_cache = {};

//               var order_locations = [];
//               results.faves.forEach(function (fave) {
//                 // if (!order_locations.contains(fave.vendorid)) {
//                 if (
//                   !order_locations.length ||
//                   !order_locations.includes(fave.vendorid)
//                 ) {
//                   order_locations.push(fave.vendorid);
//                 }
//               });

//               var menus_cached = 0;
//               order_locations.forEach(function (order_location) {
//                 $.ajax({
//                   type: "POST",
//                   url: ajax_url,
//                   data: {
//                     action: "get_olo_get_menu",
//                     restaurant_id: order_location,
//                   },
//                   success: function (response) {
//                     menu_results_cache[order_location] = JSON.parse(response);
//                     menus_cached++;

//                     if (menus_cached == order_locations.length) {
//                       results.faves.forEach(function (fave) {
//                         var $fave_order = $(
//                           "[data-favorite-order-template].hide"
//                         ).clone();
//                         $fave_order
//                           .find("[data-favorite-order-title]")
//                           .text(fave.name);
//                         $fave_order
//                           .find("[data-favorite-order-id]")
//                           .text(fave.id);
//                         $fave_order.find(".favorite-order-id").text(fave.id);
//                         $fave_order
//                           .find("[data-favorite-order-vendor-id]")
//                           .text(fave.vendorid);
//                         $fave_order
//                           .find("[data-favorite-order-vendor-name]")
//                           .text(fave.vendorname);

//                         var menu_results = menu_results_cache[fave.vendorid];

//                         fave.products.forEach(function (product) {
//                           var matched = false;
//                           var product_calories;
//                           var product_price;
//                           var product_image_filename;

//                           menu_results.categories.every(function (category) {
//                             category.products.every(function (cat_product) {
//                               if (product.productid == cat_product.id) {
//                                 product_calories = cat_product.basecalories;
//                                 // product_price = cat_product.cost;
//                                 product_image_path = menu_results.imagepath;
//                                 product_image_filename =
//                                   cat_product.imagefilename;
//                                 matched = true;
//                               }
//                               return !matched;
//                             });
//                             return !matched;
//                           });

//                           var $fave_item = $fave_order
//                             .find("[data-favorite-order-item-template]")
//                             .clone();

//                           if (product_image_filename != null) {
//                             $fave_item
//                               .find("img")
//                               .attr(
//                                 "src",
//                                 product_image_path + product_image_filename
//                               );
//                           } else {
//                             $fave_item
//                               .find("img")
//                               .attr(
//                                 "src",
//                                 "/wp-content/themes/wildfire/assets/images/ecw-product-placeholder.svg"
//                               );
//                           }

//                           $fave_item
//                             .find("[data-favorite-order-item-name]")
//                             .text(product.name);
//                           if (product_calories != null) {
//                             $fave_item
//                               .find("[data-favorite-order-item-calories]")
//                               .text(product_calories + " Calories | ");
//                           }
//                           // $fave_item.find('[data-favorite-order-item-price]').text(product_price);

//                           var choiceArray = [];
//                           product.choices.forEach(function (choice) {
//                             choiceArray.push(choice.name);
//                           });

//                           $fave_item.removeClass("hide");
//                           $fave_item
//                             .find("[data-favorite-order-item-choices]")
//                             .text(choiceArray.join(", "));
//                           $fave_item.removeAttr(
//                             "data-favorite-order-item-template"
//                           );
//                           $fave_order
//                             .find(".favorite-order-items")
//                             .append($fave_item);
//                         });

//                         $fave_order.removeClass("hide");
//                         $("[data-favorite-orders-list]").append($fave_order);

//                         $(".account-favorite-button").click(function () {
//                           $(".data-delete-fave-id").text(
//                             $(this).parent().find(".favorite-order-id").text()
//                           );
//                           $(".account-delete-favorite-order").foundation(
//                             "open"
//                           );
//                         });

//                         $(".account-delete-favorite-button").click(function () {
//                           $.ajax({
//                             type: "POST",
//                             url: ajax_url,
//                             data: {
//                               action: "olo_delete_fave",
//                               authtoken: localStorage.getItem(
//                                 "ecw_auth_token"
//                               ),
//                               faveid: $("[data-delete-fave-id]").text(),
//                             },
//                             success: function (response) {
//                               window.location.reload();
//                             },
//                           });
//                         });

//                         $("[data-favorite-orders-loading]").addClass("hide");
//                         $("[data-favorite-orders-list]").removeClass("hide");

//                         $(".fave-order-place-button").click(function () {
//                           $(".data-order-type-recent-id").text("");
//                           $(".data-order-type-fave-id").text(
//                             $(this)
//                               .closest(".favorite-order")
//                               .find("[data-favorite-order-id]")
//                               .text()
//                           );
//                           window.scrollTo(0, 0);
//                           $("#home-select-order-type").foundation("open");
//                         });
//                       });

//                       $(".home-favorite-button").click(function () {
//                         if ($(this).hasClass("location-favorite-active")) {
//                           $(
//                             ".home-delete-favorite-order-favorite-order-id"
//                           ).text(
//                             $(this).parent().find(".favorite-order-id").text()
//                           );
//                           $("#home-delete-favorite-order").foundation("open");
//                         } else {
//                           $(".home-add-favorite-order-recent-order-id").text(
//                             $(this).parent().find(".recent-order-id").text()
//                           );
//                           $("#home-add-favorite-order").foundation("open");
//                         }
//                       });

//                       $(".home-confirm-add-favorite-button").click(function () {
//                         $.ajax({
//                           type: "POST",
//                           url: ajax_url,
//                           data: {
//                             action: "olo_create_basket_from_order",
//                             authtoken: localStorage.getItem(
//                               "ecw_auth_token"
//                             ),
//                             orderid: $(
//                               ".home-add-favorite-order-recent-order-id"
//                             ).text(),
//                           },
//                           success: function (response) {
//                             result = JSON.parse(response);
//                             // console.log(response);
//                             // console.log(result);

//                             $.ajax({
//                               type: "POST",
//                               url: ajax_url,
//                               data: {
//                                 action: "olo_set_fave",
//                                 authtoken: localStorage.getItem(
//                                   "ecw_auth_token"
//                                 ),
//                                 basketid: result.id,
//                                 description: $(
//                                   "[data-favorite-order-description]"
//                                 ).val(),
//                               },
//                               success: function (response) {
//                                 fave_result = JSON.parse(response);

//                                 if (fave_result.code == 200) {
//                                   alert(fave_result.message);
//                                   $(".home-add-favorite-order").foundation(
//                                     "open"
//                                   );
//                                 } else if (fave_result.faves[0].id) {
//                                   window.location.reload();
//                                 }
//                               },
//                             });
//                           },
//                         });
//                       });

//                       $(".home-confirm-delete-favorite-button").click(
//                         function () {
//                           $.ajax({
//                             type: "POST",
//                             url: ajax_url,
//                             data: {
//                               action: "olo_delete_fave",
//                               authtoken: localStorage.getItem(
//                                 "ecw_auth_token"
//                               ),
//                               faveid: $(
//                                 ".home-delete-favorite-order-favorite-order-id"
//                               ).text(),
//                             },
//                             success: function (response) {
//                               window.location.reload();
//                             },
//                           });
//                         }
//                       );

//                       totalLoadBeforeComplete--;
//                       if (totalLoadBeforeComplete == 0) {
//                         ecw_hide_loading();
//                       }
//                     }
//                   },
//                   complete: function () {
//                     totalLoadBeforeComplete--;
//                     if (totalLoadBeforeComplete == 0) {
//                       ecw_hide_loading();
//                     }
//                   },
//                 });
//               });
//             } else {
//               $("[data-favorite-orders-loading]").addClass("hide");
//               $("[data-favorite-orders-not-found]").removeClass("hide");
//             }
//           },
//           complete: function () {
//             totalLoadBeforeComplete--;
//             if (totalLoadBeforeComplete == 0) {
//               ecw_hide_loading();
//             }
//           },
//         });
//       }
//     })
//     .hide()
//     .fadeIn(transitionDuration);
// }

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function eraseCookie(name) {
  let date = new Date();
  date.setTime(date.getTime() + (-1));
  let expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + "" + expires + "; path=/";
}

// // Start a recent order
// function startRecentOrder(order_id, view_context) {
//   var $ = jQuery;

//   // console.log("Start Recent: " + order_id);

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: {
//       action: "olo_create_basket_from_order",
//       authtoken: localStorage.getItem("ecw_auth_token"),
//       orderid: order_id,
//     },
//     success: function (response) {
//       result = JSON.parse(response);
//       // console.log(response);
//       // console.log(result);

//       if (result.id) {
//         // console.log("setting basket id to new basket: " + result.id);
//         localStorage.setItem("ecw_customer_basket_id", result.id);
//         localStorage.setItem(
//           "ecw_customer_store_location_id",
//           result.vendorid
//         );

//         $.when(olo_get_restaurant(result.vendorid)).done(function (
//           restaurant_json
//         ) {
//           var restaurant = JSON.parse(restaurant_json);
//           localStorage.setItem(
//             "ecw_customer_store_location_name",
//             restaurant.name
//           );
//           hideFakeMenuIfAddedLocation();

//         });

//         var validAddress = true;
//         // var isDelivery = Boolean($('input[name="order-type"]:checked').val() == 'dispatch');
//         var isDelivery = Boolean(
//           $('input[name="' + view_context + '-order-type"]:checked').val() ==
//           "dispatch"
//         );
//         var vendorid = result.vendorid;
//         var supportsbaskettransfers = result.supportsbaskettransfers;

//         // Delivery requires a full address, thus fails validation if no street address is present
//         if (
//           isDelivery &&
//           !$("#" + view_context + "-order-location-search-streetaddress").val()
//             .length
//         ) {
//           validAddress = false;
//         }

//         // console.log("validAddress", validAddress);

//         $("#" + view_context + "-order-location-search").removeClass(
//           "form-alert"
//         );
//         $("#" + view_context + "-order-location-search-error").addClass("hide");

//         if (validAddress) {
//           ecw_show_loading();
//           setAddressComponents(view_context);

//           var showcartdialog = true;
//           // console.log('asdgadsg');

//           selectLocation(
//             vendorid,
//             supportsbaskettransfers,
//             showcartdialog,
//             view_context
//           );
//         } else {
//           $("#" + view_context + "-order-location-search").addClass(
//             "form-alert"
//           );
//           $("#" + view_context + "-order-location-search-error").removeClass(
//             "hide"
//           );
//         }
//       }
//     },
//   });
// }

// Start a favorite order
// function startFavoriteOrder(fave_id, view_context) {
//   var $ = jQuery;

//   // console.log("Start Favorite: " + fave_id);

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: {
//       action: "olo_create_basket_from_fave",
//       authtoken: localStorage.getItem("ecw_auth_token"),
//       faveid: fave_id,
//     },
//     success: function (response) {
//       result = JSON.parse(response);
//       // console.log(response);
//       // console.log(result);

//       if (result.id) {
//         // console.log("setting basket id to new basket: " + result.id);
//         localStorage.setItem("ecw_customer_basket_id", result.id);
//         localStorage.setItem(
//           "ecw_customer_store_location_id",
//           result.vendorid
//         );

//         $.when(olo_get_restaurant(result.vendorid)).done(function (
//           restaurant_json
//         ) {
//           var restaurant = JSON.parse(restaurant_json);
//           localStorage.setItem(
//             "ecw_customer_store_location_name",
//             restaurant.name
//           );
//           hideFakeMenuIfAddedLocation();

//         });

//         var validAddress = true;
//         // var isDelivery = Boolean($('input[name="order-type"]:checked').val() == 'dispatch');
//         var isDelivery = Boolean(
//           $('input[name="' + view_context + '-order-type"]:checked').val() ==
//           "dispatch"
//         );
//         var vendorid = result.vendorid;
//         var supportsbaskettransfers = result.supportsbaskettransfers;

//         // Delivery requires a full address, thus fails validation if no street address is present
//         if (
//           isDelivery &&
//           !$("#" + view_context + "-order-location-search-streetaddress").val()
//             .length
//         ) {
//           validAddress = false;
//         }

//         // console.log("validAddress", validAddress);

//         $("#" + view_context + "-order-location-search").removeClass(
//           "form-alert"
//         );
//         $("#" + view_context + "-order-location-search-error").addClass("hide");

//         if (validAddress) {
//           ecw_show_loading();
//           setAddressComponents(view_context);

//           var showcartdialog = true;
//           // console.log('dgdsg');

//           selectLocation(
//             vendorid,
//             supportsbaskettransfers,
//             showcartdialog,
//             view_context
//           );
//         } else {
//           $("#" + view_context + "-order-location-search").addClass(
//             "form-alert"
//           );
//           $("#" + view_context + "-order-location-search-error").removeClass(
//             "hide"
//           );
//         }
//       }
//     },
//   });
// }

// Start a referral order
function startReferralOrder(location_id, supportsbaskettransfers, view_context) {
  var $ = jQuery;

  // console.log('Start Referral: ' + location_id);
  localStorage.setItem('ecw_customer_store_location_id', location_id);

  var validAddress = true;
  var isDelivery = Boolean($('select[name="' + view_context + '-order-type"]').val() == 'dispatch');
  var vendorid = location_id;

  // Delivery requires a full address, thus fails validation if no street address is present
  if (isDelivery && !$('#' + view_context + '-order-location-search-streetaddress').val().length) {
    validAddress = false;
  }

  // console.log('validAddress', validAddress);

  $('#' + view_context + '-order-location-search').removeClass('form-alert');
  $('#' + view_context + '-order-location-search-error').addClass('hide');

  if (validAddress) {
    ecw_show_loading();

    eraseCookie('ecw_google_store_slug');
    eraseCookie('ecw_google_handoff_mode');

    setAddressComponents(view_context);

    var showcartdialog = false;
    // console.log('asdg'); 

    selectLocation(vendorid, supportsbaskettransfers, showcartdialog, view_context);

  } else {
    $('#' + view_context + '-order-location-search').addClass('form-alert');
    $('#' + view_context + '-order-location-search-error').removeClass('hide');
  }
}

// Set Payment Splits
function setPaymentSplit() {
  var $ = jQuery;
  var splitCount = $(
    "[data-billing-schemes-active] .active-payment:not(.hide)"
  ).length;

  // Auto set split payments evenly between
  calcSplitPayment();

  if (splitCount > 1) {
    // console.log("split payment");
    $("[data-split-totals]").removeClass("hide");
    $("[data-billing-schemes-parent]").addClass("split-payment");
    $("[data-billing-schemes-active] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split-input]").removeClass("hide");
      }
    );
    // Balance inputs while editing
    $("[data-billing-schemes-active] .active-payment:not(.hide) input").on(
      "keyup",
      function () {
        // calcSplitPayment();
        balanceSplitPayment(this);
      }
    );
    $("[data-billing-schemes-active] .active-payment:not(.hide) input").on(
      "blur",
      function () {
        fillEmptySplitPayment();
      }
    );
  } else {
    // console.log("single payment");
    $("[data-split-totals]").addClass("hide");
    $("[data-billing-schemes-parent]").removeClass("split-payment");

    $("[data-billing-schemes-active] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split-input]").addClass("hide");
      }
    );

    $("[data-billing-schemes-active] .active-payment:not(.hide) input").off(
      "keyup blur"
    );
  }
}

function calcSplitPayment() {
  var $ = jQuery;

  // var totalToSplit = Number($("[data-cart-grand-total]").attr("data-cart-grand-total"));
  // var totalToSplit = Number($('[data-cart-grand-total]').attr('data-cart-grand-total').replace(',', ''));
  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );

  var splitCount = $("[data-billing-schemes-active] .active-payment:not(.hide)").length;
  var totalSplits = 0;
  var remainingBalance = 0;

  $("[data-total-to-split]").text("$ " + formatMoney(totalToSplit));

  // for (var i = 0; i < splitCount - 1; i++) {
  //   var inputVal = Number(formatMoney((totalToSplit * 100) / splitCount / 100));
  //   $(
  //     $("[data-billing-schemes-active] .active-payment:not(.hide) input")[i]
  //   ).val(formatMoney(inputVal));
  //   totalSplits += inputVal;
  // }
  //
  // remainingBalance = totalToSplit - totalSplits;
  // $($("[data-billing-schemes-active] .active-payment:not(.hide) input")[splitCount - 1]).val(formatMoney(remainingBalance));

  // console.log("total to split", totalToSplit, formatMoney(totalToSplit));

  $($('[data-billing-schemes-active] .active-payment:not(.hide) input')[splitCount - 1]).val(formatMoney(totalToSplit));
  for (var i = 0; i < splitCount - 1; i++) {
    $($('[data-billing-schemes-active] .active-payment:not(.hide) input')[i]).val(formatMoney(0));
  }

  // $("[data-remaining-balance]").text("$ 0.00");
}

// Balance split payments
// Balance split payments
function balanceSplitPayment(activeElement) {
  var $ = jQuery;

  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );
  var $activeInputs = $("[data-billing-schemes-active] .active-payment:not(.hide) input");
  var splitCount = $activeInputs.length - 1;
  var totalSplits = 0;

  $("[data-total-to-split]").text("$ " + formatMoney(totalToSplit));

  // 1. First pass: Calculate current totals
  $activeInputs.each(function () {
    totalSplits += Number($(this).val()) || 0;
  });

  var remainingBalance = Math.round((totalToSplit - totalSplits) * 100) / 100;

  // 2. Adjust other inputs based on overpayment or underpayment
  if (activeElement && remainingBalance !== 0) {

    // CASE A: User entered too much (Overpayment) -> Drain other cards
    if (remainingBalance < 0) {
      var overage = Math.abs(remainingBalance);

      $activeInputs.each(function () {
        if (this === activeElement) return; // Skip active input
        if (overage <= 0) return; // Stop if we've successfully absorbed the overage

        var currentVal = Number($(this).val()) || 0;

        if (currentVal > 0) {
          // Deduct either the full overage, or whatever is left on this card
          var deductAmount = Math.min(currentVal, overage);
          var newVal = currentVal - deductAmount;

          $(this).val(newVal.toFixed(2));

          // Reduce the remaining overage we need to account for
          overage = Math.round((overage - deductAmount) * 100) / 100;
        }
      });
    }

    // CASE B: User entered too little (Underpayment) -> Add to another card
    else if (remainingBalance > 0) {
      var deficit = remainingBalance;

      $activeInputs.each(function () {
        if (this === activeElement) return; // Skip active input
        if (deficit <= 0) return; // Stop if we've allocated the deficit

        var currentVal = Number($(this).val()) || 0;
        var newVal = currentVal + deficit;

        $(this).val(newVal.toFixed(2));

        // We drop the deficit to 0 since one card absorbed the whole remaining balance
        deficit = 0;
      });
    }

    // Recalculate totals after adjusting the other cards
    totalSplits = 0;
    $activeInputs.each(function () {
      totalSplits += Number($(this).val()) || 0;
    });
    remainingBalance = Math.round((totalToSplit - totalSplits) * 100) / 100;
  }

  // console.log('totalToSplit', totalToSplit);
  // console.log('totalSplits', totalSplits);
  // console.log('splitCount', splitCount);
  // console.log('remainingBalance', remainingBalance);

  // 3. Update the UI
  $("[data-remaining-balance]").text("$ " + formatMoney(remainingBalance));

  if (remainingBalance !== 0) {
    $(".remaingin-balance-row").addClass("error");
  } else {
    $(".remaingin-balance-row").removeClass("error");
  }
} // balanceSplitPayment()


function fillEmptySplitPayment() {
  var $ = jQuery;
  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );
  var totalSplits = 0;

  // Get collective total
  $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(
    function () {
      if ($(this).val() !== "") {
        totalSplits += (Number($(this).val()) * 100) / 100;
      }
    }
  );

  $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(
    function () {
      if ($(this).val() === "") {
        $(this).val(formatMoney(totalToSplit - totalSplits));
        // We don't pass an active element here because it's an auto-fill
        balanceSplitPayment();
        return false;
      }
    }
  );

  balanceSplitPayment();
} // fillEmptySplitPayment()

// Set CC Fields for CC payment entry
function setCCFields() {
  var $ = jQuery;

  $(".credit-card-info-div").empty();
  $(".cvv-info-div").empty();
  $("#expiredate").val("");
  $("#postalCode").val("");

  $("#credit-card-add-card").prop("disabled", true);
  $("#credit-card-add-card").removeClass("hide");
  $("#credit-card-update-card").prop("disabled", true);
  $("#credit-card-update-card").addClass("hide");

  var cardFieldStyle =
    "width: 100%;" +
    "height: 100%;" +
    "margin: 0;" +
    "padding: 8px;" +
    "border-width: 0px;" +
    "border-radius: 0;" +
    "background-color: #fff;" +
    "font-size: 14px;" +
    "font-weight: 500;" +
    "font-family: ff-good-headline-web-pro-nar, sans-serif;" +
    "line-height: 1.5;" +
    "color: #6A6869;" +
    "appearance: none;";

  checkoutFrame = new Olo.CheckoutFrame({
    cardElement: "credit-card-info-div",
    cvvElement: "cvv-info-div",
  });

  var checkoutFrameInit = {
    brandAccessId: brandAccessId, // global set in wp-content/themes/Charleys/parts/block/content-wf-ordering.php
    basketGuid: localStorage.getItem("ecw_customer_basket_id"),
    styles: {
      "cardNumber": cardFieldStyle,
      "cvv": cardFieldStyle,
    },
    cardNumber: {
      placeholder: "Card Number",
    },
    cvv: {
      placeholder: "CVV",
    },
  };

  // console.log("checkoutframeinit: ", checkoutFrameInit);

  checkoutFrame.initialize(checkoutFrameInit);
} // setCCFields

function setCheckoutError(errorMessage) {
  var $ = jQuery;
  if (errorMessage == "") {
    errorMessage =
      "We were unable to process your order at this time. Plase insure the information provided below is correct.";
  }
  $("html, body").animate({ scrollTop: 0 }, 500);
  $(".checkout-error [data-error-message]").text(errorMessage);
  $(".checkout-error").removeClass("hide").attr("aria-hidden", "false")
    .attr("tabindex", "-1")
    .focus();
}

function clearCheckoutError() {
  var $ = jQuery;
  $(".checkout-error [data-error-message]").text("");
  $(".checkout-error").addClass("hide").attr("aria-hidden", "true")
    .removeAttr("tabindex");
}

// function punchh_get_all_restaurants() {
//   var $ = jQuery;
//   //olo_get_all_restaurants
//   return $.ajax({ 
//     type: 'POST',
//     url: ajax_url,
//     data: {
//       action : 'punchh_get_all_restaurants'
//     },
//     success: function(response) {
//       // console.log(response);
//       // console.log(JSON.parse(response));
//       //
//       // var results = JSON.parse(response);
//     },
//     complete: function() {
//
//     }
//   });
// }

function olo_get_rewards_schemes() {
  var $ = jQuery;

  if (
    localStorage.getItem("ecw_auth_token") &&
    localStorage.getItem("ecw_customer_basket_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_rewards_schemes",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        authtoken: localStorage.getItem("ecw_auth_token"),
        referer: window.location.href,

      },
      success: function (response) {
        // console.log(JSON.parse(response));
        var result = JSON.parse(response);
        if ("schemes" in result) {
          if ("membership" in result.schemes[0]) {
            if (result.schemes[0].membership !== null) {
              localStorage.setItem(
                "ecw_customer_membership_id",
                result.schemes[0].membership.id
              );
              // olo_get_qualifying_rewards();
            }
          }
        }
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_applied_rewards() {
  var $ = jQuery;
  if (localStorage.getItem("ecw_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_applied_rewards",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        membershipid: localStorage.getItem("ecw_customer_membership_id"),
        referer: window.location.href,

      },
      success: function (response) {
        // console.log(response);
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_qualifying_rewards() {
  var $ = jQuery;

  if (
    localStorage.getItem("ecw_auth_token") &&
    localStorage.getItem("ecw_customer_basket_id") &&
    localStorage.getItem("ecw_customer_membership_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_qualifying_rewards",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        authtoken: localStorage.getItem("ecw_auth_token"),
        membershipid: localStorage.getItem("ecw_customer_membership_id"),
        referer: window.location.href,

      },
      success: function (response) {
        // console.log('olo_get_qualifying_rewards', JSON.parse(response));
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_add_reward_to_basket(reward_reference) {
  var $ = jQuery;

  if (
    localStorage.getItem("ecw_auth_token") &&
    localStorage.getItem("ecw_customer_basket_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_add_reward_to_basket",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        membershipid: localStorage.getItem("ecw_customer_membership_id"),
        references: reward_reference,
        referer: window.location.href,

      },
      success: function (response) {

        var result = JSON.parse(response);
        // console.log('olo_add_reward_to_basket', result);

        if ("code" in result) {
          console.log('error response', result);

          setCheckoutError(result.message);
        } else {
          clearCheckoutError();
        }
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_remove_reward_to_basket(rewardid) {
  var $ = jQuery;

  if (localStorage.getItem("ecw_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_remove_reward_to_basket",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        rewardId: rewardid,
        referer: window.location.href,

      },
      success: function (response) {
        // console.log(response);
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_gift_card_balance(billingSchemeId, cardnumber, pin) {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_gift_card_balance",
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      billingSchemeId: billingSchemeId,
      cardnumber: cardnumber,
      pin: pin,
      referer: window.location.href
    },
    success: function (response) {
      // console.log(JSON.parse(response));
    },
    complete: function () { },
  });
}

function olo_get_all_restaurants() {
  var $ = jQuery;
  //olo_get_all_restaurants
  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_all_restaurants",
      referer: window.location.href

    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      //
      // var results = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_get_user_details() {
  var $ = jQuery;
  // olo_get_user_details
  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_details",
        authtoken: localStorage.getItem("ecw_auth_token"),
        referer: window.location.href
      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_user_contact_details() {
  var $ = jQuery;

  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_contact_details",
        authtoken: localStorage.getItem("ecw_auth_token"),
        referer: window.location.href

      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_user_communication_details() {
  var $ = jQuery;

  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_communication_details",
        authtoken: localStorage.getItem("ecw_auth_token"),
        referer: window.location.href

      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_billing_accounts() {
  var $ = jQuery;

  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_billing_accounts",
        authtoken: localStorage.getItem("ecw_auth_token"),
        referer: window.location.href,

      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

// Sets billing account to default
function olo_default_billing_account(billingAccountId) {
  var $ = jQuery;

  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_default_billing_account",
        authtoken: localStorage.getItem("ecw_auth_token"),
        billingAccountId: billingAccountId,
        referer: window.location.href,

      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

// Deletes Billing Account
function olo_delete_billing_account(billingAccountId) {
  var $ = jQuery;

  if (localStorage.getItem("ecw_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_delete_billing_account",
        authtoken: localStorage.getItem("ecw_auth_token"),
        billingAccountId: billingAccountId,
        referer: window.location.href,

      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

function olo_get_billing_schemes() {
  var $ = jQuery;

  if (localStorage.getItem("ecw_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_billing_schemes",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        referer: window.location.href
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        //
        // var results = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_validate_basket() {
  var $ = jQuery;

  if (localStorage.getItem("ecw_customer_basket_id")) {
    // console.log('olo_validate_basket called');
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_validate_basket",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        referer: window.location.href,

      },
      success: function (response) {
        // console.log('olo_validate_basket', JSON.parse(response));
        //
        // var results = JSON.parse(response);
        // console.log('validate basket', response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_get_ccsf_payment_token() {
  var $ = jQuery;
  // if(!localStorage.getItem('ecw_customer_ccsf_token')) {
  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_ccsf_payment_token",
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      authtoken: localStorage.getItem("ecw_auth_token"),
      referer: window.location.href

    },
    success: function (response) {
      // console.log(response);
      // console.log('olo_get_ccsf_payment_token', JSON.parse(response));
      //
      // var results = JSON.parse(response);
      //
      // localStorage.setItem('ecw_customer_ccsf_token', results.accesstoken);
    },
    complete: function () { },
  });
  // } else {
  //   return [JSON.stringify({
  //     accesstoken: localStorage.getItem('ecw_customer_ccsf_token')
  //   })];
  // }
}



// New recursion method
function getSelectedModifiers(choiceID) {
  var $ = jQuery.noConflict();
  var selectedModifiers = [];

  // capture product modifiers
  if ($('[data-modifier-for="' + choiceID + '"]').length) {

    // Find the modifiers for this selection
    $('[data-modifier-for="' + choiceID + '"]').each(function () {

      var modifierID = $(this).attr('data-modifier-id');

      // Get the selected options for this modifier
      $('input[data-option-for-modifier="' + modifierID + '"]:checked').each(function () {

        var subChoiceQty = 1;
        var subChoiceId = $(this).attr("id");
        var subChoice = [];
        var subChoiceChainID = $(this).attr("data-chainoptionid");

        var subChoiceName = $('label[for="' + subChoiceId + '"] strong').text()
        var subChoiceModLevel = Number($(this).attr('data-modifier-level'));

        // Adjust qty
        if ($('[data-qty-for="' + subChoiceId + '"]').length) {
          if (
            $('[data-qty-for="' + subChoiceId + '"]').is(
              'input[type="radio"]'
            )
          ) {
            subChoiceQty = Number(
              $('[data-qty-for="' + subChoiceId + '"]:checked').val()
            );
          } else {
            subChoiceQty = Number(
              $('[data-qty-for="' + subChoiceId + '"]').val()
            );
          }
        }

        var subChoice = {
          // name: subChoiceName, // Debug field (optioal)
          chainchoiceid: subChoiceChainID,
          quantity: subChoiceQty,
          // modifierLevel: subChoiceModLevel, // Debug field (optioal)
          choices: getSelectedModifiers(subChoiceId)
        };

        selectedModifiers.push(subChoice);

      });

    });
  }

  return selectedModifiers;
}

function updateItemInBasket() {
  var $ = jQuery;

  ecw_show_loading();

  console.log("update item");

  var productSelections = {
    productid: Number(
      $("#item-add-to-cart-update").attr("data-update-product-id")
    ),
    quantity: Number($("input#product-item-qty").val()),
    choices: [],
    recipient: $("#item-customer-name").val(),
  };

  var $productView = $("#product-detail-view");
  var productVariant = [];

  $productView
    .find(
      "input[data-item-selector]:checked, input[data-item-selector-modifier]:checked"
    )
    .each(function () {
      var choiceQty = 1;
      var choiceID = $(this).attr("id");
      var chainOptionID = $(this).attr("data-chainoptionid");

      if (chainOptionID) {
        if ($('[data-qty-for="' + choiceID + '"]').length) {
          if (
            $('[data-qty-for="' + choiceID + '"]').is('input[type="radio"]')
          ) {
            choiceQty = Number(
              $('[data-qty-for="' + choiceID + '"]:checked').val()
            );
          } else {
            choiceQty = Number($('[data-qty-for="' + choiceID + '"]').val());
          }
        }

        var choice = {
          choiceid: $(this).attr("id"),
          quantity: choiceQty,
        };

        productSelections.choices.push(choice);
        productVariant.push($(this).next("label").find("strong").text());
      }
    });

  // console.log(productVariant);

  var itemPrice = Number(
    $("#item-add-to-cart")
      .find("[data-item-selection-price]")
      .text()
      .replace("$ ", "")
  );

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  var addToCartData = {
    event: "add_to_cart",
    ecommerce: {
      currency: "USD",
      value: itemPrice,
      items: [
        {
          item_id: $("#item-add-to-cart").attr("data-menu-selection-id"),
          item_name: $("#product-detail-view")
            .find("[data-product-view-title]:first")
            .text(),
          affiliation: localStorage.getItem(
            "ecw_customer_store_location_name"
          ),
          price: itemPrice,
          item_variant: productVariant.join(", "),
          quantity: Number($("input#product-item-qty").val()),
        },
      ],
    },
  };
  const hasExtraCookieConsent = checkNonNecessaryConsent();
  if (hasExtraCookieConsent) {
    // console.log("GA4:", addToCartData);
    window.dataLayer.push(addToCartData);
  }


  productSelections = {
    products: [productSelections],
  };

  // console.log(JSON.stringify(productSelections));

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_update_basket_product",
      productSelections: JSON.stringify(productSelections),
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      referer: window.location.href,
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      var result = JSON.parse(response);
    },
    complete: function () {
      // Close menu selection modal
      // $("#product-detail-view").foundation("close");
      // Reset the current state to the menu view
      // if (window.location.hash !== "#menu-product-view") {
      //   history.replaceState({}, "", "#menu");
      // }
      console.log('update basket test #6');

      updateBasketDisplay(true);
      ecw_hide_loading();
    },
  });
}
var $ = jQuery;

function selectAllDefaultSelectsion(element, currentInputId) {
  // console.log('triggered selectAllDefaultSelectsion function');
  var $ = jQuery;

  $matchingChildFieldset = $(element).closest('.product-option-group').find(`fieldset[data-modifier-for="${currentInputId}"]`);
  if ($matchingChildFieldset.length > 0) {
    // console.log('matchingChildFieldset found');
    $defaultInputBoxes = $matchingChildFieldset.find('span input[radiodefualtcheckedstate]');
    if ($defaultInputBoxes.length > 0) {
      // console.log('$defaultInputBoxes', $defaultInputBoxes);

      $defaultInputBoxes.each(function () { // Iterate through each element in $defaultInputBoxes
        const $defaultInputBox = $(this); // Wrap the current element in jQuery
        // const $defaultInputBoxesLabel = $defaultInputBox.siblings('label'); // scope this to only look at the single item
        // console.log('$defaultInputBox', $defaultInputBox);

        $defaultInputBox.prop('checked', true);
        $defaultInputBox.parent().addClass('selected');

        //see if clindren have default selects
        const defaultInputBoxesId = $defaultInputBox.attr('id');
        $matchingChildChildFieldset = $defaultInputBox.closest('fieldset').siblings(`fieldset[data-modifier-for="${defaultInputBoxesId}"]`);

        if ($matchingChildChildFieldset.length > 0) {
          $childDefaultInputBoxes = $matchingChildChildFieldset.find('span input[radiodefualtcheckedstate]');
          if ($childDefaultInputBoxes.length > 0) {
            // console.log('$childDefaultInputBoxes', $childDefaultInputBoxes); 

            $childDefaultInputBoxes.prop('checked', true);
            $childDefaultInputBoxes.parent().addClass('selected');
          }
        }
        //ingredent popup
        $matchingChildChildIngredientFieldset = $defaultInputBox.closest('.product-modifier-groups').siblings('#main-ingredient-customizer-information-parent').find(`fieldset[data-modifier-for="${defaultInputBoxesId}"]`);
        // console.log('$matchingChildChildIngredientFieldset ', $matchingChildChildIngredientFieldset);

        if ($matchingChildChildIngredientFieldset.length > 0) {
          $childDefaultInputBoxes = $matchingChildChildIngredientFieldset.find('span input[radiodefualtcheckedstate]');
          if ($childDefaultInputBoxes.length > 0) {
            // console.log('$childDefaultInputBoxes', $childDefaultInputBoxes); 

            $childDefaultInputBoxes.prop('checked', true);
            $childDefaultInputBoxes.parent().addClass('selected');
          }
        }
      });
    }
    // validateItemForm();

  }
}

function validateItemForm(heatLevelChanage, inputChanged = jQuery(this)) {
  var $ = jQuery;
  if (inputChanged && inputChanged.length && inputChanged.is('input')) {
    // console.log('validate form', inputChanged, inputChanged.attr('id'));
    selectAllDefaultSelectsion(inputChanged, inputChanged.attr('id'));
  }

  if (heatLevelChanage) {

    let $fakeDropdownButton = inputChanged.closest('.accordion-panel').find('.product-modifier-groups .accordion-trigger-fake-dropdown');

    $fakeDropdownButton.removeClass('selected');
    $fakeDropdownButton.find('svg').remove();
    $fakeDropdownButton.find('strong').text("Choose your heat level");

  }
  // Update Visual Selection
  $(
    "[data-product-options] input[data-item-selector], [data-modifier-group] input[data-item-selector-modifier], [data-product-option-modifier-option] input[data-item-selector-modifier], [main-ingredient-customizer-information-popup] input[data-item-selector-modifier]"
  ).each(function () {
    if ($(this).prop("checked")) {
      $(this).parent().addClass("selected");
    } else {
      $(this).parent().removeClass("selected");
    }

    if ($(this).prop("checked") && $(this).is('.accordion-panel-fake-dropdown input')) {
      let selectedInputBox = $(this);
      let selectedInputBoxID = selectedInputBox.attr('id')
      let selectedLabelName = $(selectedInputBox.siblings('label').find('strong'))
        .clone()                 // clone so we don’t modify DOM
        .children()              // target child elements (like span)
        .remove()                // remove them
        .end()
        .text()
        .trim();

      let selectedSVG = $(selectedInputBox.siblings('svg'));
      const clonedSVG = selectedSVG.clone();

      let selectedSpan = selectedInputBox.closest('span');
      let allClasses = selectedSpan.attr('class');
      let filteredSelectedClasses = allClasses.replace(/all-other-modifier-children/g, '').trim();

      let selectedFieldset = selectedSpan.closest('fieldset');
      let selectedFieldsetFor = selectedFieldset.attr('id');
      let accordionButton = $(`button.accordion-trigger-fake-dropdown[aria-controls="${selectedFieldsetFor}"]`);

      // console.log('accordionButton', selectedInputBox, selectedFieldsetFor);
      //remove popup stuff
      let corrispondingPopupButton = $(`fieldset[data-modifier-for="${selectedInputBoxID}"]`);
      corrispondingPopupButton.removeClass('selected');
      //close accordian
      accordionButton.attr('aria-expanded', 'false');
      selectedFieldset.attr('hidden', 'hidden');
      // Delete any existing SVGs inside the button && add selection to dropdown
      accordionButton.find('svg').remove();
      accordionButton.removeClass('dry-rub').removeClass('virgin').removeClass('mild').removeClass('medium').removeClass('hot').removeClass('x-hot').removeClass('volcanic').removeClass('insanity');
      accordionButton.addClass(filteredSelectedClasses);
      accordionButton.find('strong').text(selectedLabelName);
      accordionButton.prepend(clonedSVG);

    } else if ($(this).prop("checked") && $(this).is('fieldset[data-fake-id] input')) {
      console.log('flavor option clicked');
      let selectedInputBox = $(this);
      let selectedLabelName = $(selectedInputBox.siblings('label').find('strong')).text();
      let selectedFieldset = selectedInputBox.closest('fieldset');

      let selectedFieldsetFor = selectedFieldset.attr('data-modifier-for');

      if (!selectedFieldsetFor) {
        selectedFieldsetFor = selectedFieldset.attr('data-chainmodifierid');
      }

      let popupButton = $(`button#customizer-information-popup[data-modifier-for="${selectedFieldsetFor}"], button#customizer-information-popup[data-chainmodifierid="${selectedFieldsetFor}"]`);

      popupButton.attr('data-is-valid', 'true').addClass('selected').text(selectedLabelName);
      // console.log('selectedInputBox', selectedInputBox);
    }


  });



  $("[data-product-option-group]:not(.hide)").each(function () {
    var $productOptionGroup = $(this);
    var $productOptions = $(this).find(
      "[data-product-options]:not(.hide), [data-modifier-group][data-maxselects]:not(.option-hide), [data-modifier-group]:not(.option-hide), [data-modifier-group-for-fake-dropdown]:not(.option-hide), [main-ingredient-customizer-information-popup]:not(.option-hide)"
    );

    // Selectors
    $productOptions.each(function () {
      // console.log('Raw maxSelects:', $(this).attr("data-maxselects"));
      var minSelects = Number($(this).attr("data-minselects")) || 0,
        maxSelects = Number($(this).attr("data-maxselects")) || 0,
        minChoiceQty = Number($(this).attr("data-minchoicequantity")) || 0,
        minAggregateChoiceQty = Number($(this).attr("data-minaggregateselects")) || 0,
        maxChoiceQty = Number($(this).attr("data-maxchoicequantity")) || 0,
        isValid = $(this).attr("data-is-valid"),
        isRequired = $(this).attr("data-is-required");

      // console.log('minAggregateChoiceQty', minAggregateChoiceQty);
      // console.log('this', $(this).find('legend').text());
      // Set Valid State
      var fieldsetValid = true;

      // Enable/Disable Selectors based on max qty
      var $qtyInput = $(this).find('input[data-item-selector]:checked').siblings('.quantity-container').find('input.qtyinput');
      if (minAggregateChoiceQty !== 0 && $qtyInput && $qtyInput.length && $qtyInput !== 0) {
        var totalInputQty = 0;
        $qtyInput.each(function () {
          totalInputQty += parseInt($(this).val(), 10) || 0;
        });
      }

      if (maxSelects !== 0) {
        var selectedQty = 0;
        $(this)
          .find("input[data-item-selector]:checked, input[data-item-selector-modifier]:checked")
          .each(function () {
            var selectionID = $(this).attr("id");
            var itemQty = 0;
            $(
              'input[radio][data-qty-for="' + $(this).attr("id") + '"]:checked, input[type="number"][data-qty-for="' + $(this).attr("id") + '"]'
            ).each(function () {
              itemQty += Number($(this).val());
            });
            if (itemQty == 0) {
              itemQty = 1;
            }
            // console.log("itemQty: " + itemQty);
            selectedQty += itemQty;
          });
        // console.log('selectedQty: '+selectedQty);
        // if(selectedQty == 0) {
        //   selectedQty = 1;
        // }
        // Disable if not available
        if (
          $(this)
            .find("input[data-item-selector], input[data-item-selector-modifier]")
            .attr("data-available-now") == "false"
        ) {
          $(this).find("input[data-item-selector], input[data-item-selector-modifier]").prop("disabled", true);
        }

        // Don't allow user to select more then allowed
        if (selectedQty == maxSelects || totalInputQty == maxSelects) {
          $(this)
            .find("input[data-item-selector]:not(:checked, [type='radio']), input[data-item-selector-modifier]:not(:checked, [type='radio'])")
            .prop("disabled", true);
          $(this)
            .find("button.qtyplus")
            .prop("disabled", true);
          $(this)
            .find('input[type="radio"][value="2"].qtyinput:not(:checked)')
            .prop("disabled", true);
        } else {
          $(this).find("input[data-item-selector], input[data-item-selector-modifier]").prop("disabled", false);
          $(this)
            .find("button.qtyplus, button.qtyminus, input.qtyinput")
            .prop("disabled", false);
          $(this)
            .find('input[type="radio"].qtyinput:not(:checked)')
            .prop("disabled", false);
        }



      }

      if (isRequired) {
        var numSelected = $(this).find(
          "input[data-item-selector]:checked, input[data-item-selector-modifier]:checked"
        ).length;


        if (numSelected < minSelects || !numSelected) {
          fieldsetValid = false;
        }
        if ((totalInputQty < minAggregateChoiceQty)) {
          fieldsetValid = false;
          // console.log('i invalid', $(this).find('legend').text());
        }
      }
      if (totalInputQty > maxSelects) {
        fieldsetValid = false;
        console.log('too big!');

      }

      $(this).attr("data-is-valid", fieldsetValid);

      // console.log();
    });

    // Show/Hide product quantity selectors
    $productOptions.find("[data-qty-container-for]").each(function () {
      var selectedItem = $(this).attr("data-qty-container-for");

      if (
        $(
          'input[data-item-selector][id="' +
          selectedItem +
          '"], input[data-item-selector-modifier][id="' +
          selectedItem +
          '"]'
        ).prop("checked")
      ) {
        $(this).removeClass("option-hide"); // Show QTY Selector
      } else {
        $(this).addClass("option-hide"); // Hide QTY Selector
        $(this)
          .find("input[data-item-selector-modifier]")
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    });

    // Show/Hide Modifiers
    $productOptionGroup.find("[data-modifier-for]").each(function () {
      var selectedItem = $(this).attr("data-modifier-for");

      if (
        $('input[data-item-selector][id="' + selectedItem + '"]').prop("checked") || $('input[data-item-selector-modifier][id="' + selectedItem + '"]').prop("checked")
      ) {
        $(this).removeClass("option-hide"); // Show Modifier
      } else {
        $(this).addClass("option-hide"); // Hide Modifier
        $(this)
          .find("input[data-item-selector-modifier]")
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    });


  });
  //dropdowns 
  $(".accordion>div.accordion-panel:not(.hide)").each(function () {
    var $productOptions = $(this).find(
      "[data-product-options]:not(.hide), [data-modifier-group][data-maxselects]:not(.option-hide), [data-modifier-group]:not(.option-hide), [data-modifier-group-for-fake-dropdown]:not(.option-hide), [main-ingredient-customizer-information-popup]:not(.option-hide)"
    );
    var fieldsetValid = true;
    $productOptions.each(function () {
      if ($(this).attr("data-is-valid") === "false") {
        fieldsetValid = false;
        return false; // stop checking further
      }
    });
    // console.log('fieldsetValid', fieldsetValid);

    if (fieldsetValid) {
      $(this).siblings('button.accordion-trigger').attr("data-is-valid", "true");
      // console.log('$productOptions', $productOptions);
    }


  });
  var formValid = false;

  if (!$('[data-is-valid="false"]:not(.option-hide)').length) {
    formValid = true;
  }

  if (formValid) {
    $("#item-add-to-cart").prop("disabled", false);
    $("#item-add-to-cart-update").prop("disabled", false);
  } else {
    $("#item-add-to-cart").prop("disabled", true);
    $("#item-add-to-cart-update").prop("disabled", true);
  }

  // console.log("Form Status: " + formValid);
  return formValid;
}

function calculateProductTotal() {
  var $ = jQuery;

  var itemTotal = 0;
  var itemCalories = 0;

  $(
    "[data-product-selection-list] [data-product-selection-item]:not(.hide)"
  ).remove();

  $(
    "#product-detail-view [data-base-price] input[data-item-selector]:checked, #product-detail-view [data-product-option-group]:not(.hide) fieldset:not(.option-hide) input[data-item-selector]:checked, #product-detail-view [data-product-option-group]:not(.hide) fieldset:not(.option-hide) input[data-item-selector-modifier]:checked"
  ).each(function () {
    var selectedID = $(this).attr("id");

    var selectedQty = 0;
    $(
      'input[type="radio"][data-qty-for="' +
      $(this).attr("id") +
      '"]:checked, input[type="number"][data-qty-for="' +
      $(this).attr("id") +
      '"]'
    ).each(function () {
      selectedQty += Number($(this).val());
    });

    if (selectedQty == 0) {
      selectedQty = 1;
    }

    // console.log('ID: ' + selectedID, 'Label: ' + $('label[for="'+$(this).attr('id')+'"]').text(), 'Cost: $'+formatMoney($(this).attr('data-cost')), 'Qty: ' + selectedQty);

    itemTotal += Number($(this).attr("data-cost")) * selectedQty;
    if ($(this).attr("data-calories")) {
      // console.log('itemCalories', Number($(this).attr("data-calories")));

      itemCalories += Number($(this).attr("data-calories")) * selectedQty;
      // console.log('itemCalories', $(this).siblings('label').text(), itemCalories);
    } else {
      // console.log('askjfgaskjf', this);
    }

    // Add item to list
    var $itemSelectorContainer = $("[data-product-selection-list]");
    var $itemSelectorItem = $(
      "[data-product-selection-list] [data-product-selection-item].hide"
    ).clone();
    var itemID = $(this).attr("id");
    var itemName = $("label[for=" + itemID + "]")
      .find("strong")
      .text();

    var itemQty = 1;
    if ($('input[data-qty-for="' + itemID + '"]:checked').length) {
      itemQty = Number($('[data-qty-for="' + itemID + '"]:checked').val());
    }
    if ($('input[type="number"][data-qty-for="' + itemID + '"]').length) {
      itemQty = Number(
        $('input[type="number"][data-qty-for="' + itemID + '"]').val()
      );
    }

    if (itemQty > 1) {
      itemName = itemName + " (" + itemQty + ")";
    }

    if (itemName.length) {
      $itemSelectorItem.text(itemName);
      $itemSelectorItem.attr("data-item-id", itemID);

      $itemSelectorItem.removeClass("hide");
      $itemSelectorContainer.append($itemSelectorItem);

      $itemSelectorItem.click(function () {
        var unselectID = $(this).attr("data-item-id");
        $("#" + unselectID)
          .prop("checked", false)
          .change();
        // console.log("unselected", $("#" + unselectID));
      });
    } else {
      $itemSelectorItem.remove();
    }
  });

  // console.log('Total: ', '$'+formatMoney(itemTotal));

  var productQty = $("input#product-item-qty").val();

  itemTotal *= Number(productQty);
  itemCalories *= Number(productQty);
  if (itemCalories != 0 || itemCalories != '0') {
    $("[data-product-total-calories]").text(itemCalories + " Calories");
  }
  $("[data-item-selection-price]").text("$ " + formatMoney(itemTotal));
}

function clearProductOptions() {
  // Clears out all options in preparation for loading another set of options.
  var $ = jQuery;
  $("#product-detail-view [data-product-option-group]:not(.hide)").each(
    function () {
      $(this).remove();
    }
  );
}

function clearBasketSession() {
  console.log('clearBasketSession');
  var $ = jQuery;

  // Address Selections
  localStorage.removeItem("ecw_customer_address_selected");
  localStorage.removeItem("ecw_customer_address_streetaddress");
  localStorage.removeItem("ecw_customer_address_city");
  localStorage.removeItem("ecw_customer_address_zipcode");

  // Modes
  localStorage.removeItem("ecw_customer_deliverymode");
  localStorage.removeItem("ecw_customer_schedule");
  localStorage.removeItem("ecw_original_customer_schedule");

  // Basket
  localStorage.removeItem("ecw_customer_basket_id");

  // Payment Token
  localStorage.removeItem("ecw_customer_ccsf_token");

  // Schedule
  localStorage.removeItem("ecw_customer_scheduled_time");
  localStorage.removeItem("ecw_customer_scheduled_day");

  // Guest Checkout
  // localStorage.removeItem("ecw_customer_guest_first_name");
  // localStorage.removeItem("ecw_customer_guest_last_name");
  // localStorage.removeItem("ecw_customer_guest_phone_number");
  // localStorage.removeItem("ecw_customer_guest_email");
  // console.log('update basket test #7');

  updateBasketDisplay();
}

function ecw_set_form_errors(errorData, $form) {
  var $ = jQuery;
  // console.log('error $form', $form);

  if (errorData) {
    Object.keys(errorData).forEach((k, i) => {
      // console.log(result.data.errors[k]);
      if ($('input[name="' + k + '"]').length) {
        var $inputErrorMessage = $('input[name="' + k + '"]').next();
        $inputErrorMessage.attr("original-error", $inputErrorMessage.text());
        $inputErrorMessage.text(errorData[k]);
        // $form.foundation("addErrorClasses", $('input[name="' + k + '"]'), []);
      }

      if (k == "base") {
        $form.find("[data-abide-error] p").text(errorData[k]);
      }
    });
  }

  $form.find("[data-abide-error]").show();
} // ecw_set_form_errors

function punchh_get_user_offers() {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_get_user_offers",
      accesstoken: localStorage.getItem("ecw_access_token"),
    },
    success: function (response) {
      // console.log(response);
    },
    complete: function () {
      ecw_hide_loading();
    },
  });
}

function punchh_get_user_points() {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_get_user_points",
      accesstoken: localStorage.getItem("ecw_access_token"),
    },
    success: function (response) {
      // console.log(response);
    },
    complete: function () {
      ecw_hide_loading();
    },
  });
}

function punchh_olo_sso(providertoken, refresh_token, isNewAccount = false) {
  var $ = jQuery;

  // console.log("olo_ss0", providertoken);

  localStorage.setItem("ecw_access_token", providertoken);
  // console.log('providertoken', providertoken)
  // localStorage.setItem("ecw_user_id", provideruserid);

  var olo_sso_creds = {
    provider: "paytronix",
    providertoken: providertoken,
    refresh_token: refresh_token,
    basketid: $('input[name="basketGuid"]').val(),
  };

  if (isNewAccount) {
    olo_sso_creds.firstname = $('input[name="first_name"]').val();
    olo_sso_creds.lastname = $('input[name="last_name"]').val();
    olo_sso_creds.contactnumber = $('input[name="phone"]')
      .val()
      .replace(/[^\d.-]/g, "");
    olo_sso_creds.emailaddress = $('input[name="email"]').val();
  }

  // console.log(olo_sso_creds);

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_olo_authenticate",
      olo_sso_creds: olo_sso_creds,
      referer: window.location.href,

    },
    success: function (response) {
      // console.log(JSON.parse(response));

      var result = JSON.parse(response);
      // console.log('punchh_olo_authenticate response', result);

      localStorage.setItem("ecw_auth_token", result.authtoken);
      $('.accountButton').removeClass("hide");
      $('.signInButton').addClass("hide");
      if ($('.wf-ordering-group-login').length) {
        location.reload();
      } else {
        olo_login_route();
      }

    },
    complete: function () {
      isSubmitting = false;
      ecw_hide_loading();
      ecw_hide_overloading();

    },
  });
}

function olo_login_route() {
  // Check for basket
  if (localStorage.getItem("ecw_customer_basket_id")) {
    change_view("checkout");
  } else {
    change_view("home");
  }
}

// function olo_set_fave_location(restaurant_id) {
//   var $ = jQuery;

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: {
//       action: "olo_set_fave_location",
//       authtoken: localStorage.getItem("ecw_auth_token"),
//       restaurant_id: restaurant_id,
//     },
//     success: function (response) { },
//     complete: function () { },
//   });
// }

// function olo_delete_fave_location(restaurant_id) {
//   var $ = jQuery;

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: {
//       action: "olo_delete_fave_location",
//       authtoken: localStorage.getItem("ecw_auth_token"),
//       restaurant_id: restaurant_id,
//     },
//     success: function (response) { },
//     complete: function () { },
//   });
// }

// function olo_get_nearby_locations(lat, lng, dist, view_context) {
//   // console.log("get nearby locations");

//   ecw_show_loading();

//   // console.log("getLocations", lat, lng, dist);
//   var $ = jQuery;

//   var nearbyData = {
//     action: "get_nearby_locations",
//     lat: lat,
//     long: lng,
//     distance: dist,
//   };

//   // if($('[name="order-type"]:checked').val() == 'dispatch') {
//   //if($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch') {
//   //  nearbyData.is_delivery = true;
//   //}

//   $.ajax({
//     type: "POST",
//     url: ajax_url,
//     data: nearbyData,
//     success: function (response) {
//       // console.log(response);
//       var result = JSON.parse(response);
//       userHasSearched = true;
//       if (result.status == "success" && result.data !== null) {
//         // console.log('result.data.restaurants', result.data.restaurants);
//         //var isDelivery = false;
//         // if($('[name="order-type"]:checked').val() == 'dispatch') {
//         //if($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch') {
//         //  isDelivery = true;
//         //}

//         set_location_selections(result.data.restaurants, view_context, lat, lng);
//         // ecw_hide_loading();
//       } else {
//         // console.log('no result.data.restaurants', result.data.restaurants);

//         set_location_selections({}, view_context);
//         // ecw_hide_loading();
//       }
//     },
//     complete: function () { },
//   });
// }

// function clearLocationList() {
//   var $ = jQuery;
//   // move the order type selector outside of the location item so it doesn't get wiped out
//   $("#start-order-order-location-search-error-delivery").addClass("hide");
//   $("#start-order-order-location-search-error").addClass("hide");
//   $(".wf-ordering-start-order").append(
//     $("#start-order-select-order-type-embedded")
//   );
//   // Clear any restaurant listings
//   $("[data-location-list] [data-location-item-template]:not(.hide)").remove();

//   //
//   if ($("#google-map").length) {
//     $('#google-map').html(''); // Clear the map container div
//     map = new google.maps.Map(document.getElementById('google-map'), {
//       center: { lat: 39.8283, lng: -98.5795 }, // Fallback center: USA
//       zoom: 4, // Zoom out to see the whole country initially
//       mapTypeControl: false,
//       fullscreenControl: false,
//       styles: mapStyle // Assuming mapStyle is a global variable
//     });
//   }

//   // console.log('dfsghasdgsdg');

// }

// function set_location_selections(restaurants, view_context, searchedLat, searchedLng) {
//   var $ = jQuery;

//   console.log('users entered location', searchedLat, searchedLng);

//   clearLocationList();

//   //var orderType = $('input[name="' + view_context + '-order-type"]:checked').val();

//   // Hide not found message
//   $("[data-location-not-found]").addClass("hide");
//   $("[data-location-found]").addClass("hide");
//   $("[data-location-not-selected]").addClass("hide");

//   $("#" + view_context + "-order-location-search").removeClass("form-alert");
//   $("#" + view_context + "-order-location-search-error").addClass("hide");
//   $("#" + view_context + "-order-location-search-error-delivery").addClass(
//     "hide"
//   );

//   // Clear all Google Maps markers
//   if ($("#google-map").length) {
//     for (var m = 0; m < order_markers.length; m++) {
//       order_markers[m].setMap(null); // Removes the marker from the map
//     }
//     order_markers = [];
//   }

//   // Create a Set to keep track of processed restaurant IDs
//   const processedIds = new Set();
//   if (restaurants !== null && restaurants.length) {
//     const firstLocation = restaurants[0];

//     for (var i = 0; i < restaurants.length; i++) {

//       const restaurant = restaurants[i];
//       if (!processedIds.has(restaurant.id)) {

//         processedIds.add(restaurant.id);
//         getLocationInfo();

//         function getLocationInfo() {
//           if (restaurant.isavailable) {
//             // Ensure store is available 

//             console.log('location info', restaurant);
//             var order_markers = [];

//             if ($('#google-map').length) {
//               // Check if the restaurant has location data and use the first one for the center
//               if (firstLocation) {
//                 centerCoords = {
//                   lat: parseFloat(firstLocation.latitude),
//                   lng: parseFloat(firstLocation.longitude)
//                 };
//               } else {
//                 centerCoords = { lat: 39.8283, lng: -98.5795 }; // Fallback center
//               }

//               var map = new google.maps.Map(document.getElementById('google-map'), {
//                 center: centerCoords,
//                 zoom: 6,
//                 mapTypeControl: false,
//                 fullscreenControl: false,
//                 styles: mapStyle
//               });


//               const selectedIcon = {
//                 url: '/wp-content/themes/wildfire/assets/images/icons/icon-map-marker-selected.svg',
//                 scaledSize: new google.maps.Size(70, 70)
//               };

//               const defaultIcon = {
//                 url: '/wp-content/themes/wildfire/assets/images/icons/icon-map-marker.svg',
//                 scaledSize: new google.maps.Size(50, 50)
//               };

//               for (var i = 0; i < restaurants.length; i++) {
//                 const restaurant = restaurants[i]; // safer reference
//                 const isNearest = localStorage.getItem("ecw_visitor_nearest_location_id") == restaurant.id;

//                 const marker = new google.maps.Marker({
//                   position: {
//                     lat: parseFloat(restaurant.latitude),
//                     lng: parseFloat(restaurant.longitude)
//                   },
//                   map: map,
//                   title: restaurant.name,
//                   icon: isNearest ? selectedIcon : defaultIcon
//                 });

//                 const order_popupHTML =
//                   '<div class="title"><strong>' + restaurant.name + '</strong></div>' +
//                   '<div class="address">' +
//                   restaurant.streetaddress + '<br>' +
//                   restaurant.city + ', ' +
//                   restaurant.state + ' ' +
//                   restaurant.zip +
//                   '</div>' +
//                   '<div class="phone"><a href="tel:' + restaurant.telephone + '" class="underline">' +
//                   restaurant.telephone +
//                   '</a></div>';

//                 attachInfoWindow(marker, order_popupHTML);

//                 order_markers.push(marker);
//               }

//               const sharedInfoWindow = new google.maps.InfoWindow();

//               function attachInfoWindow(marker, content) {
//                 marker.addListener('click', function () {
//                   // Close & set info window

//                   sharedInfoWindow.setContent(content);
//                   sharedInfoWindow.open(marker.getMap(), marker);

//                   // Reset all markers to default icon
//                   for (let m = 0; m < order_markers.length; m++) {
//                     order_markers[m].setIcon(defaultIcon);
//                   }

//                   // Highlight clicked marker
//                   marker.setIcon(selectedIcon);

//                   setAsStore(restaurant.id);
//                 });
//               }


//             }


//             var supportedOrderTypes = [];

//             // Since we have to use olo_check_delivery_coverage, php will convert booleans to strings in json.
//             var canDispatch =
//               restaurant.supportsdispatch === "true"
//                 ? true
//                 : restaurant.supportsdispatch === "false"
//                   ? false
//                   : restaurant.supportsdispatch;
//             if (canDispatch) {
//               supportedOrderTypes.push("dispatch");
//             }
//             var canCurbside =
//               restaurant.supportscurbside === "true"
//                 ? true
//                 : restaurant.supportscurbside === "false"
//                   ? false
//                   : restaurant.supportscurbside;
//             if (canCurbside) {
//               supportedOrderTypes.push("curbside");
//             }
//             var canPickup =
//               restaurant.canpickup === "true"
//                 ? true
//                 : restaurant.canpickup === "false"
//                   ? false
//                   : restaurant.canpickup;
//             if (canPickup) {
//               supportedOrderTypes.push("pickup");
//             }
//             var canDinein =
//               restaurant.supportsdinein === "true"
//                 ? true
//                 : restaurant.supportsdinein === "false"
//                   ? false
//                   : restaurant.supportsdinein;
//             if (canDinein) {
//               supportedOrderTypes.push("dinein");
//             }

//             var $locationItem = $('#order-location-list [data-location-item-template].hide').clone();

//             var locationHours = '';

//             $.each(restaurant.calendar, function (key, calendar) {
//               // console.log('calendar', calendar);
//               if (typeof calendar.ranges !== 'undefined' && calendar.ranges !== null && calendar.ranges.length) {
//                 var storeCalendar = calendar.ranges[0];
//                 var startDate = new Date(storeCalendar.start.substr(0, 4) + '-' + storeCalendar.start.substr(4, 2) + '-' + storeCalendar.start.substr(6, 2) + 'T' + storeCalendar.start.substr(9, 5));
//                 var endDate = new Date(storeCalendar.end.substr(0, 4) + '-' + storeCalendar.end.substr(4, 2) + '-' + storeCalendar.end.substr(6, 2) + 'T' + storeCalendar.end.substr(9, 5));

//                 var hourslabel = calendar.type.charAt(0).toUpperCase() + calendar.type.substr(1).toLowerCase();
//                 if (calendar.label !== null) {
//                   hourslabel = calendar.label.charAt(0).toUpperCase() + calendar.label.substr(1).toLowerCase();
//                 } else if (calendar.type == 'dinein') {
//                   hourslabel = "Dine In";
//                 }
//                 if (calendar.type === 'business') { // Focus only on 'business' hours for this check
//                   var now = new Date(); // Get the current date and time

//                   // Iterate through *all* ranges within this 'business' calendar entry
//                   $.each(calendar.ranges, function (index, range) {
//                     // Parse the end time for the current range
//                     var endStr = range.end;
//                     var endDate = new Date(
//                       endStr.substr(0, 4) + '-' +  // YYYY
//                       endStr.substr(4, 2) + '-' +  // MM
//                       endStr.substr(6, 2) + 'T' +  // DD
//                       endStr.substr(9, 5)          // HH:MM
//                     );

//                     // Check if the endDate is for *today*
//                     if (endDate.getFullYear() === now.getFullYear() &&
//                       endDate.getMonth() === now.getMonth() &&
//                       endDate.getDate() === now.getDate()) {
//                       // Calculate the difference in milliseconds
//                       var diffMs = endDate.getTime() - now.getTime();

//                       // Convert milliseconds to minutes
//                       var diffMinutes = diffMs / (1000 * 60);

//                       // Check if current time is within 30 minutes *before* closing time
//                       if (diffMinutes >= 0 && diffMinutes <= 30) {
//                         // console.log('within 30 min');
//                         $locationItem.addClass('hide-asap-option');
//                       } else {
//                         // console.log('not before 30 min close');
//                         $locationItem.removeClass('hide-asap-option');
//                       }
//                     }
//                   });
//                 }
//                 locationHours += hourslabel + ' Hours: ' + formatAMPM(startDate) + ' - ' + formatAMPM(endDate) + '<br>';
//               }
//             });


//             $locationItem.find('[data-location-hours]').html(locationHours);
//             $locationItem.find('.order-button').attr('data-store-url', restaurant.url);
//             $locationItem.find('.order-button').attr('data-store-number', restaurant.extref);


//             $locationItem.find(".pickup-button").click(function () {
//               // window.location.href = $(this).closest('.location-item').find('.order-button').attr('data-store-url');
//             });

//             new Foundation.Accordion($locationItem.find('[data-accordion]'));

//             if (restaurant.customerfacingmessage) {
//               $locationItem.find('[data-location-customer-message]').text(restaurant.customerfacingmessage);
//               $locationItem.find('[data-location-customer-message]').removeClass('hide');
//             }

//             $locationItem.find("[data-location-name]").html(restaurant["name"]);

//             // Fav button
//             if (
//               localStorage.getItem("ecw_visitor_nearest_location_id") ==
//               restaurant["id"]
//             ) {
//               $locationItem.addClass("current-location").find(".set-location-button")
//                 .addClass("current-location");
//               $locationItem
//                 .find(".set-location-button .subheading")
//                 .text("YOUR SELECTED LOCATION");
//             }

//             $locationItem
//               .find(".set-location-button")
//               .attr("data-location-id", restaurant["id"]);
//             $locationItem
//               .find(".set-location-button")
//               .attr("data-title", restaurant["name"]);
//             // console.log('adsgasdg', restaurant);
//             $locationItem
//               .find(".set-location-button")
//               .attr("data-permalink", restaurant["permalink"]);
//             $locationItem
//               .find(".set-location-button")
//               .attr("data-store-id", restaurant["extref"]);
//             $locationItem
//               .find(".set-location-button")
//               .attr("data-location-groups", restaurant["location_groups"]);

//             if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes($locationItem.attr("data-store-number")))) {
//               $locationItem
//                 .find(".set-location-button")
//                 .attr("data-order-url", "/order/?store=" + restaurant["slug"]);
//             } else {
//               $locationItem
//                 .find(".set-location-button")
//                 .attr("data-order-url", restaurant["url"]);
//             }
//             $locationItem.find(".set-location-button").click(function () {
//               console.log('user clicked on different store');
//               setAsStore(
//                 $(this).attr("data-location-id"),
//                 $(this).attr("data-title"),
//                 $(this).attr("data-order-url"),
//                 $(this).attr("data-permalink"),
//                 $(this).attr("data-store-id"),
//                 $(this).attr("data-location-groups"),
//                 set_store_location = true,
//                 order_markers,
//                 update_map_marker = true

//               );
//             });

//             // console.log('distance: ', restaurant['distance'], Number(restaurant['distance']));

//             if (restaurant["distance"] == 0) {
//               $locationItem.find("[data-location-distance]").addClass("hide");
//             }
//             $locationItem
//               .find("[data-location-distance]")
//               .text(restaurant["distance"] + " miles away");

//             var storeAddress =
//               restaurant["streetaddress"] +
//               " " +
//               restaurant["city"] +
//               ", " +
//               restaurant["state"] +
//               " " +
//               restaurant["zip"];
//             $locationItem.find("[data-location-address]").html(storeAddress);
//             $locationItem
//               .find("[data-location-phone]")
//               .attr("href", "tel:" + restaurant["telephone"].replace(/[\s()-]/g, ""))
//               .text(restaurant["telephone"]);

//             $locationItem
//               .find(".location-learn-more")
//               .attr("href", restaurant["permalink"]);

//             $locationItem.attr("data-store-number", restaurant["extref"]);
//             $locationItem.attr("data-store-url", restaurant["url"]);

//             $locationItem.attr("data-location-id", restaurant["id"]);
//             $locationItem.attr("data-location-name", restaurant["name"]);
//             $locationItem.attr(
//               "data-location-address",
//               restaurant["streetaddress"]
//             );
//             $locationItem.attr(
//               "data-location-city-zip",
//               restaurant["city"] +
//               ", " +
//               restaurant["state"] +
//               " " +
//               restaurant["zip"]
//             );

//             $locationItem.attr(
//               "data-supportsbaskettransfers",
//               restaurant["supportsbaskettransfers"]
//             );

//             $locationItem.find(".location-learn-more").click(function (e) {
//               e.stopPropagation();
//             });

//             supportedOrderTypes.forEach(function (supportedOrderType) {
//               $locationItem
//                 .find(".supported-order-type-" + supportedOrderType)
//                 .text("yes");
//             });

//             // Select A Location
//             $locationItem.find(".order-button").click(function () {
//               // console.log("clicked");
//               // $(this).fadeOut(400, function () {
//               //   $(this).hide(); // Optional: ensure the element is completely hidden
//               // });
//               hideFakeMenuIfAddedLocation();
//               if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes($(this).attr("data-store-number")))) {

//                 var thisOrderTypeContainer = $(this)
//                   .closest(".location-item")
//                   .find(".location-order-type-container");

//                 $("#start-order-order-location-search-error-delivery").addClass(
//                   "hide"
//                 );
//                 $("#start-order-order-location-search-error").addClass("hide");

//                 if (!thisOrderTypeContainer.hasClass("last-selected")) {
//                   $(".location-order-type-container.last-selected").addClass(
//                     "location-order-type-container-hidden"
//                   );
//                   $(".location-order-type-container").removeClass("last-selected");

//                   thisOrderTypeContainer.addClass("last-selected");

//                   $("#start-order-select-order-type-embedded").appendTo(
//                     thisOrderTypeContainer.find('[data-attach-order-type-embed]')
//                   );
//                   $("#start-order-select-order-type-embedded").removeClass("hide");
//                 }

//                 if (
//                   thisOrderTypeContainer.hasClass(
//                     "location-order-type-container-hidden"
//                   )
//                 ) {
//                   thisOrderTypeContainer.removeClass(
//                     "location-order-type-container-hidden"
//                   );

//                 } else {
//                   thisOrderTypeContainer.addClass(
//                     "location-order-type-container-hidden"
//                   );
//                 }

//                 var thisLocationItem = $(this).closest(".location-item");

//                 $(".start-order-order-type-label").show();
//                 $("#pickup").prop("checked", true).change();
//                 // $("#start-order-asap").prop("checked", true).change();

//                 if (
//                   thisLocationItem.find(".supported-order-type-pickup").text() !=
//                   "yes"
//                 ) {
//                   $("label[for='pickup']").hide();
//                   if ($("#pickup").prop("checked")) {
//                     $("#pickup").prop("checked", false);
//                     $("#curbside").prop("checked", true);
//                   }

//                 }

//                 if (
//                   thisLocationItem.find(".supported-order-type-curbside").text() !=
//                   "yes"
//                 ) {
//                   $("label[for='curbside']").hide();
//                   if ($("#curbside").prop("checked")) {
//                     $("#curbside").prop("checked", false);
//                     $("#dispatch").prop("checked", true);
//                   }
//                 }

//                 if (
//                   thisLocationItem.find(".supported-order-type-dinein").text() !=
//                   "yes"
//                 ) {
//                   $("label[for='dinein']").hide();
//                   if ($("#dinein").prop("checked")) {
//                     $("#dinein").prop("checked", false);
//                     $("#dispatch").prop("checked", true);
//                   }
//                 }

//                 if (
//                   thisLocationItem.find(".supported-order-type-dispatch").text() !=
//                   "yes"
//                 ) {
//                   $("label[for='dispatch']").hide();
//                 }

//                 $([document.documentElement, document.body]).animate(
//                   {
//                     scrollTop: $("#start-order-select-order-type-embedded")
//                       .closest(".location-item")
//                       .offset().top,
//                   },
//                   1000
//                 );

//               } else {

//                 // Opt-out store, go to store page
//                 ecw_show_loading();
//                 if (localStorage.getItem('ecw_access_token')) {
//                   window.location = 'https://order.ecw.com/login/punchh/' + localStorage.getItem('ecw_access_token');
//                 } else {
//                   window.location = $(this).attr('data-store-url');
//                 }

//               }
//               //$('.data-order-type-location-id').text($(this).attr('data-location-id'));

//               //$('#' + view_context + '-select-order-type').foundation('open');
//               //$('#' + view_context + '-select-order-type-button').trigger('click');
//             });


//             $locationItem.removeClass("hide");
//             $("[data-location-list]").append($locationItem);
//           }
//         }
//       }

//     }

//     if (!$("[data-location-list] .location-item:not(.hide)").length) {
//       if (userHasSearched) {
//         $("[data-location-not-found]").removeClass("hide");
//         // console.log('asadgsadg');

//         clearLocationList();

//       } else {
//         $("[data-location-not-selected]").removeClass("hide");
//       }
//     } else {
//       $("[data-location-found]").removeClass("hide");
//     }
//     // if ($("#tt-map").length) {

//     //   fitToMarkerBounds_order(ttmap_order);
//     // }
//     // if ($("#google-map").length) {
//     //   fitToMarkerBounds_order(map); 
//     // }
//   } else {
//     if (userHasSearched) {
//       $("[data-location-found]").addClass("hide");
//       $("[data-location-not-found]").removeClass("hide");
//       clearLocationList();

//     } else {
//       $("[data-location-not-selected]").removeClass("hide");
//     }
//   }

//   $(".location-favorite").click(function (e) {
//     e.stopPropagation();
//     if (!$(this).hasClass("location-favorite-active")) {
//       olo_delete_fave_location(
//         $(".location-favorite-active")
//           .closest(".location-item")
//           .data("location-id")
//       );

//       // $(".location-favorite-active").find(".fa-star").addClass("fa-star-o");
//       // $(".location-favorite-active").find(".fa-star").removeClass("fa-star");

//       $(".location-favorite-active").removeClass("location-favorite-active");

//       olo_set_fave_location(
//         $(this).closest(".location-item").data("location-id")
//       );

//       $(this).addClass("current-location");

//       // $(this).find(".fa-star-o").addClass("fa-star");
//       // $(this).find(".fa-star-o").removeClass("fa-star-o");
//       $(this).addClass("location-favorite-active");
//       $(this).find(".subheading")
//         .text("YOUR SELECTED LOCATION");
//     }
//   });

//   /*
//   $('#' + view_context + '-select-order-type-button').click(function() {
//     //$('#' + view_context + '-select-order-type').foundation('close');

//     var validAddress = true;
//     var isDelivery = Boolean($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch');
//     console.log('location id');
//     console.log($(this).closest('#' + view_context + '-select-order-type').find('[data-order-type-location-id]').text());
//     var vendorid = $(this).closest('#' + view_context + '-select-order-type').find('[data-order-type-location-id]').text();
//     var supportsbaskettransfers = ($(this).attr('data-supportsbaskettransfers') == 'true');

//     // Delivery requires a full address, thus fails validation if no street address is present
//     if(isDelivery && !$('#' + view_context + '-order-location-search-streetaddress').val().length) {
//       validAddress = false;
//     }

//     console.log('validAddress', validAddress);

//     $('#' + view_context + '-order-location-search').removeClass('form-alert');
//     $('#' + view_context + '-order-location-search-error').addClass('hide');

//     if(validAddress) {

//       ecw_show_loading();
//       setAddressComponents(view_context);
//       selectLocation(vendorid, supportsbaskettransfers, false, view_context);

//     } else {
//       $('#' + view_context + '-order-location-search').addClass('form-alert');
//       $('#' + view_context + '-order-location-search-error').removeClass('hide');
//     }
//   });
//   */

//   ecw_hide_loading();
// }

function selectLocation(
  vendorid,
  supportsbaskettransfers,
  showcartdialog = false,
  view_context
) {
  var $ = jQuery;
  // console.log('deliverymode', localStorage.getItem("ecw_customer_deliverymode"));

  // console.log(
  //   "selectLocation",
  //   vendorid,
  //   supportsbaskettransfers,
  //   showcartdialog,
  //   view_context
  // );
  // clearBasketSession();


  ecw_show_loading();
  $.when(olo_create_basket(vendorid, supportsbaskettransfers, reset = false)).done(function (
    ocb_json
  ) {
    var ocb = JSON.parse(ocb_json);
    // console.log('ocb_json', ocb);

    $.when(
      olo_set_basket_settings(
        view_context,
        ocb.earliestreadytime,
        Number(ocb.leadtimeestimateminutes)
      )
    ).done(function (osbs_json) {
      // Go to the restaurant menu
      var osbs = JSON.parse(osbs_json);
      // console.log('osbs', osbs);
      // Display basket setting errors
      // Dispatch address
      if ("dispatchaddress" in osbs && "code" in osbs.dispatchaddress) {
        $("[data-delivery-error]").text(osbs.dispatchaddress.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        ecw_hide_loading();
        // Time wanted
      } else if ("timewanted" in osbs && "code" in osbs.timewanted) {
        $("[data-delivery-error]").text(osbs.timewanted.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        ecw_hide_loading();
        // Delivery mode
      } else if ("deliverymode" in osbs && "code" in osbs.deliverymode) {
        $("[data-delivery-error]").text(osbs.deliverymode.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        ecw_hide_loading();
        // Otherwise, good to proceed
      } else {
        // console.log('update basket test #8');

        if ($("#home-select-order-type").length) {
          $("#home-select-order-type").foundation("close");
        }
        if ($("#account-select-order-type").length) {
          $("#account-select-order-type").foundation("close");
        }
        if ($("#location-detail-select-order-type").length) {
          $("#location-detail-select-order-type").foundation("close");
        }
        if ($("#menu-select-order-type").length) {
          $("#menu-select-order-type").foundation("close");
          $("#menu-select-order-type #start-order-order-location-search-error-delivery").addClass("hide").removeAttr("tabindex");
          $("#menu-select-order-type #start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");
        }
        // if (view_context == "menu") { 
        //   $('.menu-page-callout').insertAfter('.start-group-order');
        //   $('.menu-page-callout').removeClass('hide');
        // }
        // if (view_context == "block") {
        //   change_view("menu-cart");

        // } else {
        //   ecw_hide_loading();
        //   // change_view("menu");
        // }

        if (showcartdialog) {
          console.log('updateBasketDisplay #8');

          updateBasketDisplay(true);

          // view_cart();
          change_view('cart');
          // console.log('see_cart');
          view_cart();

        } else {
          // console.log('updateBasketDisplay #9');

          updateBasketDisplay();
          change_view("menu");

          // console.log('not view cart!');
          // console.log('not view cart!');

          not_view_cart();
        }
      }
    });
  });
}

function setGoogleReferral() {
  var $ = jQuery;

  let googleReferralToken = getCookie('ecw_google_referral_token');
  // console.log('googleReferralToken');
  // console.log(googleReferralToken);

  if (typeof googleReferralToken !== 'undefined' && googleReferralToken.length > 0) {
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'set_olo_basket_referral',
        authtoken: localStorage.getItem('ecw_auth_token'),
        basketGuid: localStorage.getItem('ecw_customer_basket_id'),
        referer: window.location.href

      }
    });
  }
}

function setAddressComponents(view_context) {
  var $ = jQuery;

  let address_selected = $("#" + view_context + "-order-location-search").val();
  if (view_context == "start-order" || view_context == "location-detail") {
    address_selected = $(
      "#" + view_context + "-order-location-search-delivery"
    ).val();
  }
  localStorage.setItem("ecw_customer_address_selected", address_selected);
  localStorage.setItem(
    "ecw_customer_address_streetaddress",
    $("#" + view_context + "-order-location-search-streetaddress").val()
  );
  localStorage.setItem(
    "ecw_customer_address_city",
    $("#" + view_context + "-order-location-search-city").val()
  );
  localStorage.setItem(
    "ecw_customer_address_zipcode",
    $("#" + view_context + "-order-location-search-zipcode").val()
  );
  // console.log('address_selected', $("#" + view_context + "-order-location-search-streetaddress").val(), "ecw_customer_address_city",
  //   $("#" + view_context + "-order-location-search-city").val(), $("#" + view_context + "-order-location-search-zipcode").val());


  // if($('[name="order-type"]:checked') == 'dispatch') {
  if (
    $('input[name="' + view_context + '-order-type"]:checked').val() ==
    "dispatch"
  ) {
    localStorage.setItem(
      "ecw_customer_address_building",
      $("#" + view_context + "-order-location-search-building").val()
    );
  } else {
    localStorage.removeItem("ecw_customer_address_building");
  }

  localStorage.setItem(
    "ecw_customer_schedule",
    $('input[name="' + view_context + '-order-schedule"]:checked').val()
  );
  localStorage.setItem(
    "ecw_original_customer_schedule",
    $('input[name="' + view_context + '-order-schedule"]:checked').val()
  );

  var deliverymode = $(
    'input[name="' + view_context + '-order-type"]:checked'
  ).val();
  // localStorage.setItem('ecw_customer_deliverymode', $('[name="order-type"]:checked').val());
  localStorage.setItem("ecw_customer_deliverymode", deliverymode);

  if (
    $('[name="' + view_context + '-order-schedule"]:checked').val() == "advance"
  ) {
    localStorage.setItem(
      "ecw_customer_scheduled_day",
      $("#" + view_context + "-time-wanted-day").val()
    );
    localStorage.setItem(
      "ecw_customer_scheduled_time",
      $("#" + view_context + "-time-wanted-time-slot").val()
    );
  } else {
    localStorage.removeItem("ecw_customer_scheduled_day");
    localStorage.removeItem("ecw_customer_scheduled_time");
  }

  // console.log('deliverymode', deliverymode);
  if (deliverymode !== 'dispatch') {
    localStorage.removeItem("ecw_customer_address_streetaddress");
    localStorage.removeItem("ecw_customer_address_zipcode");
    localStorage.removeItem("ecw_customer_address_city");
    localStorage.removeItem("ecw_customer_address_zipcode");

  }
  // console.log('deliverymode', localStorage.getItem("ecw_customer_deliverymode"));

}

function updateBasketDisplay(openBasket = false, loadWallets = false) {
  var $ = jQuery;

  // console.log("updateBasket");

  ecw_show_loading();

  canCheckout = false;

  $(".shopping-cart-icon [data-counter]").addClass("hide");

  // if(isUserLoggedIn(true)) {
  //   $('[data-group-order-button]').removeClass('hide');
  // } else {
  //   $('[data-group-order-button]').addClass('hide');
  // }

  // Session Basket ID is present, check if basket exists in OLO systems
  if (localStorage.getItem("ecw_customer_basket_id")) {
    // console.log("updateBasket if");

    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_basket",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        referer: window.location.href,

      },
      success: function (response) {
        // console.log(response);
        // console.log('customers basket', JSON.parse(response));  
        var result = JSON.parse(response);

        // reset basket
        $("[data-cart-empty]").removeClass("hide");
        $("[data-cart-product-template]:not(.hide), [data-tax-row-template]:not(.hide)").each(function () {
          $(this).remove();
        });
        $("[data-cart-upsell-items]").addClass("hide");
        $("[data-cart-totals]").addClass("hide");
        $(".shopping-cart-icon [data-counter]").addClass("hide");

        // Basket Found
        if (result.id) {
          // console.log("results", result);
          // Show cart location detail block
          $("[data-location-order-details]").removeClass("hide");
          $("[data-add-another-menu-item]").removeClass("hide");
          $("[data-start-a-new-order]").addClass("hide");

          // Set Delivery and Time Mode
          var deliverymode = result.deliverymode;
          if (result.deliverymode == "dispatch") {
            deliverymode = "Delivery";
          }
          $("[data-delivery-mode]").text(deliverymode.charAt(0).toUpperCase() + deliverymode.slice(1));
          $("[data-timemode]").text(result.timemode.toUpperCase());

          var customer_schedule = result.timemode.toUpperCase();

          // console.log(customer_schedule, result);

          if (customer_schedule !== "ASAP") {
            var timeWanted = "";
            if (result.timewanted) {
              timeWanted = result.timewanted.split(" ");
            }
            var scheduledTime = "";
            var scheduledDate = "";

            // console.log(timeWanted.length);

            if (timeWanted.length > 0) {
              scheduledDate = timeWanted[0];
              scheduledTime = timeWanted[1];
              scheduledDate =
                scheduledDate.substring(4, 6) +
                "-" +
                scheduledDate.substring(6, 8) +
                "-" +
                scheduledDate.substring(0, 4);
            }

            // console.log(scheduledTime);

            if (scheduledTime.substring(0, 2) > 12) {
              scheduledTime =
                scheduledTime.substring(0, 2) -
                12 +
                scheduledTime.substring(2) +
                " PM";
            } else {
              if (scheduledTime.substring(0, 2) == 12) {
                scheduledTime = scheduledTime + " PM";
              } else {
                scheduledTime = scheduledTime + " AM";
              }
            }

            customer_schedule =
              "at " +
              scheduledTime +
              " on " +
              scheduledDate;
          } else {
            customer_schedule =
              "" + customer_schedule.toUpperCase() + "";
          }
          $("[data-delivery-timing]").html(customer_schedule);
          $.when(
            olo_get_restaurant(
              localStorage.getItem("ecw_customer_store_location_id")
            )
          ).done(function (restaurant_data_json) {
            var restaurant_data = JSON.parse(restaurant_data_json);
            // console.log('restaurant_data', restaurant_data);
            $("[data-menu-selected-store]").text(restaurant_data.name);

            getOrderTypeEditPopupInfo();

            restaurant_data.labels.forEach(function (label) {
              if (
                label.key ==
                "handoffmode_" +
                localStorage.getItem("ecw_customer_deliverymode")
              ) {
                $("[data-menu-handoff-mode]").text(label.value);
              }
            });

            var customer_schedule = localStorage.getItem(
              "ecw_customer_schedule"
            );
            if (customer_schedule !== "asap") {
              var scheduledTime = localStorage.getItem(
                "ecw_customer_scheduled_time"
              );

              if (scheduledTime.substring(0, 2) > 12) {
                scheduledTime =
                  scheduledTime.substring(0, 2) -
                  12 +
                  scheduledTime.substring(2) +
                  " PM";
              } else {
                scheduledTime = scheduledTime + " AM";
              }

              customer_schedule =
                "at " +
                scheduledTime +
                " on " +
                localStorage.getItem("ecw_customer_scheduled_day");
            } else {
              customer_schedule = customer_schedule.toUpperCase();
            }
            $("[data-menu-handoff-time]").text(customer_schedule);

            // show formatted store hours
            var hoursCalendar;
            var calendarMatched = false;

            // if there is a specific calendar of hours for this delivery type (e.g. dispatch), use it
            // restaurant_data.calendar.every(function (calendar) {
            //   if (
            //     calendar.type ==
            //     localStorage.getItem("ecw_customer_deliverymode")
            //   ) {
            //     hoursCalendar = calendar;
            //     calendarMatched = true;
            //   }
            //
            //   return !calendarMatched;
            // });

            // otherwise use the regular business hours
            // if (calendarMatched == false) {
            //   restaurant_data.calendar.every(function (calendar) {
            //     if (calendar.type == "business") {
            //       hoursCalendar = calendar;
            //       calendarMatched = true;
            //     }
            //
            //     return !calendarMatched;
            //   });
            // }

            // format the stupid nonstandard olo dates
            // var startDateRaw = hoursCalendar.ranges[0].start;
            // var endDateRaw = hoursCalendar.ranges[0].end;
            //
            // var jsStartDate = new Date(
            //   startDateRaw.substring(0, 4),
            //   startDateRaw.substring(4, 6),
            //   startDateRaw.substring(6, 8),
            //   startDateRaw.substring(9, 11),
            //   startDateRaw.substring(12, 14),
            //   0,
            //   0
            // );
            // var jsEndDate = new Date(
            //   endDateRaw.substring(0, 4),
            //   endDateRaw.substring(4, 6),
            //   endDateRaw.substring(6, 8),
            //   endDateRaw.substring(9, 11),
            //   endDateRaw.substring(12, 14),
            //   0,
            //   0
            // );
            //
            // var startTimeFormatted = jsStartDate.toLocaleString("en-US", {
            //   hour: "numeric",
            //   minute: "numeric",
            //   hour12: true,
            // });
            // var endTimeFormatted = jsEndDate.toLocaleString("en-US", {
            //   hour: "numeric",
            //   minute: "numeric",
            //   hour12: true,
            // });
            //
            // $(".store-hours").text(
            //   "Hours " + startTimeFormatted + " - " + endTimeFormatted
            // );
            //
            // $("[data-store-info]").removeClass("hide");
          });

          // result.vendorid

          // Set Lead Time
          var leadTime = result.leadtimeestimateminutes;
          if (Number(leadTime) > 60) {
            var leadTimeHours = Math.floor(Number(leadTime) / 60);
            var leadTimeMinutes = Number(leadTime) - leadTimeHours * 60;
            leadTime = leadTimeHours + " hrs";
            if (leadTimeMinutes > 0) {
              leadTime += " " + leadTimeMinutes + " mins";
            }
          } else {
            leadTime += " mins";
          }
          $("[data-leadtimeestimateminutes]").text("(" + leadTime + " est.)");
          // Set Time wanted
          if (result.timewanted && result.deliverymode == "dispatch") {
            // console.log(result.timewanted);
            var timeWantedString =
              result.timewanted.slice(0, 4) +
              "-" +
              result.timewanted.slice(4, 6) +
              "-" +
              result.timewanted.slice(6, 8) +
              "T" +
              result.timewanted.slice(9, 14) +
              ":00";
            // console.log(timeWantedString);
            var timeWanted = new Date(timeWantedString);
            var timeWantedDisplay =
              timeWanted.toLocaleDateString("en-US") +
              " at " +
              timeWanted.toLocaleTimeString("en-US");

            $("[data-timemode]").text(
              result.timemode.toUpperCase() + " (" + timeWantedDisplay + ")"
            );
            $("[data-leadtimeestimateminutes]").text(
              "(" + timeWantedDisplay + ")"
            );
          }
          //See if ASAP is next day
          var earliestreadytime = result.earliestreadytime;
          let currentDateJs = new Date();
          if (earliestreadytime.substr(6, 2) != currentDateJs.getDate() && localStorage.getItem('ecw_original_customer_schedule') == 'asap') {
            if ($('#order-is-next-day').length) {
              setCheckoutError('This ASAP order will not be ready until after this location closes.');
              $(document).foundation();
              $('#order-is-next-day').foundation('open');
              if (result.earliestreadytime) {
                let rawDateTime = result.earliestreadytime;

                // Split date and time
                let datePart = rawDateTime.split(' ')[0];
                let timePart = rawDateTime.split(' ')[1];

                // Extract parts
                let year = datePart.substring(0, 4);
                let month = datePart.substring(4, 6);
                let day = datePart.substring(6, 8);

                // Create a new Date object
                let formattedDate = new Date(year, month - 1, day); // month is 0-indexed

                // Format nicely WITHOUT year
                let options = { month: 'long', day: 'numeric' };
                let formattedDateString = formattedDate.toLocaleDateString('en-US', options);

                // Optional: convert to 12-hour time
                let timeParts = timePart.split(':');
                let hours = parseInt(timeParts[0]);
                let minutes = timePart.split(':')[1];

                let period = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'

                let formattedTime = `${hours}:${minutes} ${period}`;

                let finalOutput = `${formattedDateString} at ${formattedTime}`;

                // console.log(finalOutput);
                $('#order-is-next-day span[data-ready-date]').text(finalOutput);
              }
            }

          }

          // Basket Products
          if (result.products.length) {
            // Display upsell Items
            if ($("[data-cart-upsell-items]").length) {
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_get_basket_upsell_items",
                  basketGuid: localStorage.getItem(
                    "ecw_customer_basket_id"
                  ),
                  referer: window.location.href,

                },
                success: function (response) {
                  var upsells = JSON.parse(response);

                  // Testing Upsell Items
                  //if(true) {
                  //   upsells = JSON.parse('{"groups": [{"title": "Desserts","items": [{"id": 416618,"name": "Green Tea","cost": "3.19","shortdescription": "A lightly sweetened mix of citrus & green tea flavors.","minquantity": 1,"maxquantity": 12}, {"id": 15510697,"name": "Spindrift - Blackberry","cost": "2.19","shortdescription": "Sparkling water with a touch of real blackberry juice","minquantity": 1,"maxquantity": 12}]}]}');
                  //}

                  // console.log('upsells: ', upsells);

                  // Clear upsell display
                  var $upsellContainer = $("[data-cart-upsell-items-list]");
                  $upsellContainer
                    .find("[data-cart-upsell-item]:not(.hide)")
                    .each(function () {
                      $(this).remove();
                    });

                  if (upsells && Array.isArray(upsells.groups) && upsells.groups.length) {
                    // $("#cart-upsell-items-list.slick-initialized").slick(
                    //   "unslick"
                    // );
                    $("[data-cart-upsell-item]:not(.hide)").remove();

                    var itemAdded = false;

                    $.each(upsells.groups, function (key, group) {
                      // console.log('group', group);
                      var firstThreeItems = group.items.slice(0, 4);

                      $.each(firstThreeItems, function (key, item) {
                        // if (item.cost !== "$0.00") {
                        // console.log('item', item);

                        var $upsellItem = $(
                          "[data-cart-upsell-item].hide"
                        ).clone();

                        if ("images" in item) {
                          // console.log('images', item.images)

                          $.each(item.images, function (key, image) {
                            if (image.groupname == "mobile-app-large") {
                              $upsellItem.find(".product-image").css({
                                "background-image":
                                  "url(" +
                                  upsells.imagepath +
                                  image.filename +
                                  ")",
                              });
                            }
                          });
                        }

                        $upsellItem
                          .find("[data-product-title]")
                          .text(toTitleCase(item.name));

                        $upsellItem
                          .find("[data-add-upsell-to-cart]")
                          .attr("data-item-id", item.id);

                        $upsellItem
                          .find("[data-description]")
                          .text(item.shortdescription);
                        if (item.cost !== "$0.00") {
                          $upsellItem
                            .find("[data-price]")
                            .html(
                              item.cost.replace("$", "$") +
                              "<small>/ea.</small>"
                            );
                        } else {
                          $upsellItem.find("[data-price]").remove();
                        }

                        $upsellItem.removeClass("hide");
                        $upsellContainer.append($upsellItem);

                        itemAdded = true;

                        $upsellItem
                          .find("[data-add-upsell-to-cart]")
                          .click(function () {
                            ecw_show_loading();

                            let productId = $(this).attr("data-item-id");
                            $.ajax({
                              type: "POST",
                              url: ajax_url,
                              data: {
                                action: "get_olo_get_menu_options",
                                productId: productId,
                                referer: window.location.href
                              },
                              success: function (response) {
                                // console.log('Raw Response:', response);

                                var optionGroups =
                                  JSON.parse(response).optiongroups;
                                // if product is customizable
                                if (optionGroups.length > 0) {
                                  // open as product detail item
                                  change_view("menu__" + productId);
                                } else {
                                  // else add directly as upsell item
                                  $.when(
                                    olo_add_upsell_items(productId, 1)
                                  ).done(function (upsell_item_json) {
                                    ecw_hide_loading();
                                    console.log('update basket test #10');

                                    // console.log(upsell_item_json);
                                    updateBasketDisplay(true);
                                  });
                                }
                              },
                            });
                          });
                        // }
                      });
                    });
                    const $accordionBtn = $(".cart-upsell-items-title");
                    const $accordionPanel = $("#cart-upsell-items-list");

                    $accordionBtn.off("click").on("click", function () {
                      // console.log('i clikc on accordina');
                      const expanded = $(this).attr("aria-expanded") === "true";
                      $(this).attr("aria-expanded", !expanded);

                      if (expanded) {
                        $accordionPanel.attr("hidden", true);
                      } else {
                        $accordionPanel.removeAttr("hidden");
                      }
                    });
                    if (itemAdded) {
                      $("[data-cart-upsell-items]").removeClass("hide");
                    }

                    // $("#cart-upsell-items-list").slick({
                    //   infinite: true,
                    //   slidesToShow: 3,
                    //   slidesToScroll: 3,
                    //   dots: true,
                    //   autoplay: false,
                    //   responsive: [
                    //     {
                    //       breakpoint: 1025,
                    //       settings: {
                    //         slidesToShow: 2,
                    //         slidesToScroll: 2
                    //       }
                    //     }
                    //   ]
                    // });
                  } else {
                    $("[data-cart-upsell-items]").addClass("hide");
                  }
                },
              });
            }

            if (result.deliverymode == "dispatch") {
              $(".location-order-details [data-row-deliverymode]").text(
                "Delivery"
              );
              // $(".location-order-details [data-store-address]").text(restaurant_data.streetaddress);
            } else {
              $(".location-order-details [data-row-deliverymode]").text(
                "Pickup"
              );
              // $(".location-order-details [data-store-address]").text(restaurant_data.streetaddress);
            }
            canCheckout = true;
            // console.log('result.products', result.products);
            let totalItems = result.products.reduce((sum, product) => {
              return sum + (product.quantity || 0);
            }, 0);

            // Update the cart icon counter
            $(".shopping-cart-icon [data-counter]").text(totalItems);
            // console.log('result.products.length', result.products.length);
            if (result.products.length === 0) {
              $(".shopping-cart-icon [data-counter]").addClass("hide")
            } else {
              $(".shopping-cart-icon [data-counter]").removeClass("hide")
            }

            //get product image call
            let restaurant_id = localStorage.getItem("ecw_customer_store_location_id");
            recipientCount = 0;
            for (var i = 0; i < result.products.length; i++) {

              var $cartProduct = $(
                "[data-cart-product-template].hide:first"
              ).clone();

              var product = result.products[i];


              $cartProduct
                .find("[data-qty]")
                .text(product.quantity);
              // if (product.quantity > 1) {
              //   $cartProduct.find("[data-qty]").removeClass("hide");
              // } else {
              //   $cartProduct.find("[data-qty]").addClass("hide");
              // }

              // Add select option for qty over 9
              //  may want to add incremental options from 9 to destination quantity?
              // console.log('product', product);
              if (product.quantity > 9) {
                $cartProduct
                  .find("[data-qty-cart-update]")
                  .append('<option>' + product.quantity + '</option>');
              }

              $cartProduct
                .find("[data-qty-cart-update]")
                .val(product.quantity);

              // Add some details 
              $cartProduct
                .find("[data-qty-cart-update]")
                .attr("data-product-id", product.id)
                .attr("data-product-choices", JSON.stringify(product.choices))
                .attr('data-product-recipient', product.recipient);

              $cartProduct
                .find("[data-product-edit-url]")
                .attr("href", "#menu_" + product.id + "_" + product.productId);

              $cartProduct
                .find("[data-product-edit-url]")
                .attr("data-product-id", product.productId);
              $cartProduct
                .find("[data-product-edit-url]")
                .attr("data-product-choices", JSON.stringify(product.choices));


              $cartProduct
                .find("[data-product-name]")
                .text(
                  product.name.toLowerCase().replace(/\b(?!\()[a-z]/g, function (char, index, fullText) {
                    // Check if the character is inside parentheses
                    if (fullText[index - 1] !== "(") {
                      return char.toUpperCase(); // Capitalize the letter if not inside parentheses
                    } else {
                      return char; // Leave the letter as lowercase if inside parentheses
                    }
                  })
                );

              $cartProduct
                .find("[data-price]")
                .text("$" + formatMoney(product.totalcost));

              if (product.choices && product.choices.length) {
                var $dataChoicesContainer = $cartProduct.find("[data-choices]");
                const choicesCount = product.choices.length;

                // Remove any existing choices to prevent duplicates on re-render
                $dataChoicesContainer.empty();

                // Loop through the product.choices
                for (let ii = 0; ii < choicesCount; ii++) {
                  let choice = product.choices[ii];
                  let choiceName = choice.name;

                  // Create a new <p> element for each choice
                  const $newParagraph = $('<p></p>');
                  $newParagraph.text(choiceName);

                  // Hide elements beyond the first two if there are more than two choices
                  if (choicesCount > 2 && ii >= 2) {
                    $newParagraph.addClass('hide');
                  }

                  $dataChoicesContainer.append($newParagraph);
                }

                // Check if a "more choices" button is needed
                if (choicesCount > 2) {
                  const $moreButton = $('<button class="more-choices-button"># more choices</button>');
                  $moreButton.text(`+ ${choicesCount - 2} more choices`);

                  $moreButton.on('click', function () {
                    const $thisButton = $(this);
                    const $hiddenChoices = $(this).siblings('p.hide');
                    const $pChoices = $(this).siblings('p');

                    if ($thisButton.hasClass('hide-choices-option')) {
                      // Currently in "hide" state, so hide all but the first two
                      $pChoices.slice(2).addClass('hide');
                      $thisButton.text(`+ ${choicesCount - 2} more choices`).removeClass('hide-choices-option');
                    } else {
                      // Currently in "show" state, so show all hidden choices
                      $hiddenChoices.removeClass('hide');
                      $thisButton.text('- hide choices').addClass('hide-choices-option');
                    }
                  });

                  $dataChoicesContainer.append($moreButton);
                }
              }
              else {
                $cartProduct.find("[data-choices]").addClass("hide");
              }


              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-id", product.id);
              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-name", product.name);
              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-price", formatMoney(product.totalcost));
              // if (choices) {
              //   $cartProduct
              //     .find("[data-remove-item]")
              //     .attr("data-product-variant", choices.join(", "));
              // } else {
              //   $cartProduct
              //     .find("[data-remove-item]")
              //     .attr("data-product-variant", "");
              // }

              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-qty", product.quantity);

              $cartProduct.find("[data-remove-item]").click(function () {
                var productId = Number($(this).attr("data-product-id"));
                var productName = $(this).attr("data-product-name");
                var productPrice = $(this).attr("data-product-price");
                var productVariant = $(this).attr("data-product-variant");
                var productQuantity = Number($(this).attr("data-product-qty"));

                // remove cart item
                ecw_show_loading();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                var addToCartData = {
                  event: "remove_from_cart",
                  ecommerce: {
                    currency: "USD",
                    value: productPrice,
                    items: [
                      {
                        item_id: productId,
                        item_name: productName,
                        affiliation: localStorage.getItem(
                          "ecw_customer_store_location_name"
                        ),
                        price: productPrice,
                        item_variant: productVariant,
                        quantity: productQuantity,
                      },
                    ],
                  },
                };
                const hasExtraCookieConsent = checkNonNecessaryConsent();
                if (hasExtraCookieConsent) {
                  window.dataLayer.push(addToCartData);

                }
                // console.log("GA4", addToCartData);

                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "olo_remove_from_basket",
                    basketGuid: localStorage.getItem(
                      "ecw_customer_basket_id"
                    ),
                    basketProductId: productId,
                    referer: window.location.href,
                  },
                  success: function (response) {
                    // console.log(response);
                    // console.log(JSON.parse(response));
                    var result = JSON.parse(response);
                  },
                  complete: function () {
                    // refresh cart view
                    console.log('update basket test #11');

                    updateBasketDisplay(true);
                  },
                });
              });
              if (product.recipient) {
                let formatRecipient = product.recipient
                  .replace(/[^a-zA-Z0-9\s]/g, '') // remove special characters
                  .replace(/\s+/g, '-')           // replace spaces with hyphens
                  .toLowerCase();                 // lowercase
                let recipientMatch = $("[data-cart-product-selections] [data-cart-product-template]." + formatRecipient);

                if (recipientMatch.length) {
                  // console.log('i have a match', product.recipient);
                  // console.log('i have a match', $("[data-cart-product-selections] [data-cart-product-template]." + formatRecipient));

                  $cartProduct.removeClass("hide");
                  $(recipientMatch).after($cartProduct);
                } else {
                  $cartProduct.addClass(formatRecipient);
                  $cartProduct.find("[data-recipient]").empty().removeClass('hide').append(product.recipient);

                  $cartProduct.removeClass("hide");
                  $("[data-cart-product-selections]").append($cartProduct);
                  recipientCount++;
                }
                if ((localStorage.getItem('ecw_customer_group_order_user_type') === "notHost") && product.recipient !== localStorage.getItem('ecw_customer_group_order_name')) {
                  $cartProduct.addClass("hide");
                }
              } else {
                $cartProduct.removeClass("hide");
                $("[data-cart-product-selections]").append($cartProduct);
              }

            }
            $("[data-participants-submitted]").text(recipientCount);
            getGroupOrder().then(function (result) {
              // console.log("Result outside function:", result);

              isSubmitting = false;
              if (result.message) {
                alert('Something went wrong. Error message: ' + result.message);


              } else {
                // console.log("Number of participants:", result.participants.length);
                $('[data-participants-invited]').text(result.participants.length);
              }
            });
            //end of get product image call

            $("[data-cart-empty]").addClass("hide");

            $("[data-cart-subtotal]").text("$ " + formatMoney(result.subtotal));
            $("[data-cart-subtotal]").attr(
              "data-cart-subtotal",
              formatMoney(result.subtotal)
            );
            // console.log('checkout results!', result);

            // Display Rewards/Discounts
            if (result.discounts && result.discounts.length) {
              for (var iv = 0; iv < result.discounts.length; iv++) {
                var $taxRow = $('[data-tax-row-template].hide').clone();
                $taxRow.find('[data-label]').text(result.discounts[iv].description);
                $taxRow.find('[data-tax]').text('($ ' + formatMoney(result.discounts[iv].amount) + ')');

                $taxRow.removeClass('hide');
                $('[data-taxes-table]').append($taxRow);
              }
            }
            // console.log('results', result, result.taxes)
            // Display taxes
            if (result.taxes && result.taxes.length) {
              for (var iii = 0; iii < result.taxes.length; iii++) {
                var $taxRow = $("[data-tax-row-template].hide").clone();
                $taxRow.find("[data-label]").text(result.taxes[iii].label);
                $taxRow
                  .find("[data-tax]")
                  .text("$ " + formatMoney(result.taxes[iii].tax));

                $taxRow.removeClass("hide");
                $("[data-taxes-table]").append($taxRow);
              }
            }

            // Display tip
            if (Number(result.tip)) {
              var $taxRow = $("[data-tax-row-template].hide").clone();
              $taxRow.find("[data-label]").text("Tip");
              $taxRow.find("[data-tax]").text("$ " + formatMoney(result.tip));

              $taxRow.removeClass("hide");
              $("[data-taxes-table]").append($taxRow);

              if ($("#custom-tip-amount").length) {
                $("#custom-tip-amount").val(formatMoney(result.tip));
              }
            }

            // Display fees
            if (result.fees && result.fees.length) {
              for (var v = 0; v < result.fees.length; v++) {
                var $taxRow = $("[data-tax-row-template].hide").clone();
                $taxRow.find("[data-label]").text(result.fees[v].amount);
                $taxRow
                  .find("[data-tax]")
                  .text("$ " + formatMoney(result.fees[v].amount));

                $taxRow.removeClass("hide");
                $("[data-taxes-table]").append($taxRow);
              }
            }

            if (result.customerhandoffcharge) {
              var $taxRow = $("[data-tax-row-template].hide").clone();

              $taxRow.find("[data-label]").text("Delivery Fee");
              $taxRow
                .find("[data-tax]")
                .text("$ " + formatMoney(result.customerhandoffcharge));

              $taxRow.removeClass("hide");
              $("[data-taxes-table]").append($taxRow);
            }

            $("[data-cart-grand-total]").attr(
              "data-cart-grand-total",
              formatMoney(result.total)
            );
            $("[data-cart-grand-total]").text("$ " + formatMoney(result.total));

            $("[data-cart-totals]").removeClass("hide");

            // display tip
            if ($("[data-tip-container]").length) {
              // console.log('result.allowstip', result.allowstip);
              if (result.allowstip) {
                // if(true) {
                $("[data-tip-container]").removeClass("hide");
                // console.log("Tip Status: ", result.allowstip);

                // if (result.deliverymode == "dispatch") {
                //   $("[data-tip-note]").text(" – 100% goes to the driver");
                // } else {
                //   $("[data-tip-note]").text(
                //     " – 100% goes to the restaurant staff"
                //   );
                // }

                // tip amount display for buttons
                $("[data-tip-amount]").each(function () {
                  var tipAmount =
                    Math.round(
                      (Number(result.subtotal) *
                        100 *
                        (Number($(this).attr("data-tip-amount")) * 100)) /
                      100
                    ) / 100;
                  // $(this).text('$ ' + formatMoney(tipAmount));
                  // $(this).parent().prev().attr('data-amount', tipAmount);
                  $(this).val(tipAmount);
                });

                $("#custom-tip-amount").inputmask({
                  alias: "numeric",
                  allowMinus: false,
                  digits: 2,
                  max: 9999.99,
                });
              } else {
                $("[data-tip-container]").addClass("hide");
              }
            }

            // Custom Fields
            if (
              result.customfields.length &&
              $("[data-custom-fields-info]").length
            ) {
              var customFields = [];
              // filter customf fields to only applicable basket types
              // console.log(result.deliverymode);
              for (var b = 0; b < result.customfields.length; b++) {
                if (
                  result.customfields[b].scope.includes(result.deliverymode) &&
                  result.deliverymode !== "pickup"
                ) {
                  // console.log(result.customfields[b].scope);
                  customFields.push(result.customfields[b]);
                }
              }

              // Put Custom Fields In Order
              customFields.sort(function (a, b) {
                if (a.id < b.id) {
                  return -1;
                }
                if (a.id > b.id) {
                  return 1;
                }
                return 0;
              });

              // console.log("custom fields", customFields);

              // If custom fields are available, display them
              if (customFields.length) {
                for (var c = 0; c < customFields.length; c++) {
                  var $cField = $(
                    "[data-custom-fields-info] [data-custom-fields-form] [data-custom-field-template].hide"
                  ).clone();
                  // console.log('customFields', customFields[c]);

                  var fieldLabel = customFields[c].label;

                  $cField
                    .find("input")
                    .attr("data-custom-field-id", customFields[c].id);
                  $cField.find("input").attr("value", customFields[c].value);

                  if (customFields[c].isrequired) {
                    $cField.find("input").prop("required", true);
                    fieldLabel += " *";
                  }
                  $cField.find("[data-custom-field-label]").text(fieldLabel);

                  //pre-set
                  const localStorageCustomerLSCarMake = localStorage.getItem("ecw_customer_car_make");
                  const localStorageCustomerLSCarModel = localStorage.getItem("ecw_customer_car_model");
                  const localStorageCustomerLSCarColor = localStorage.getItem("ecw_customer_car_color");
                  if (customFields[c].label === "Make" && localStorageCustomerLSCarMake) {
                    // console.log('make');
                    $cField.find("input").val(localStorageCustomerLSCarMake);
                  } else if (customFields[c].label === "Model" && localStorageCustomerLSCarModel) {
                    // console.log('model');
                    $cField.find("input").val(localStorageCustomerLSCarModel);

                  } else if (customFields[c].label === "Color" && localStorageCustomerLSCarColor) {
                    // console.log('color');
                    $cField.find("input").val(localStorageCustomerLSCarColor);

                  }

                  $cField.removeClass("hide");
                  $(
                    "[data-custom-fields-info] [data-custom-fields-form]"
                  ).append($cField);
                }

                // new Foundation.Abide($('#custom-fields'), {});

                $("[data-custom-fields-info]").removeClass("hide");
                $(
                  "[data-custom-fields-info] [data-custom-fields-form] [data-custom-field-template].hide"
                ).remove();
              }
            }

            updateDigitalWalletsOptions(result);
            function displaySignInForm() {
              // console.log('view login!');
              orderLogin = true;


              view_login(orderLogin);

              // view_login();
              // $("#login-rewards-prompt-view").html(loginRewardsPromptView);
              // $("#login-rewards-prompt-view").foundation("open");
              // activateSignIn($("#login-rewards-prompt-view form"));
              // $("#rewards-signup").click(displaySignUpForm);
              // $("#forgotpassword").click(function () {
              //   $("#login-rewards-prompt-view").foundation("close");
              //   displayForgotPasswordForm();
              // });
            }

            function displayForgotPasswordForm() {
              $("#forgot-prompt-view").foundation("open");
              activateForgotPassword($("#forgot-prompt-view form"));
              $("#forgot-prompt-view .login-link").click(function () {
                // $("#forgot-prompt-view").foundation("close");
                displaySignInForm();
              });
            }
            if (
              $('#g-map-popup').length &&
              localStorage.getItem("ecw_customer_store_location_id") &&
              (
                !localStorage.getItem("ecw_visitor_store_latitude") ||
                !localStorage.getItem("ecw_visitor_store_longitude")
              )
            ) {
              // console.log('call start_order_olo_get_location function');
              start_order_olo_get_location(localStorage.getItem("ecw_customer_store_location_id"));
            }
            $(".cart-checkout").off("click");
            // Checkout button
            $(".cart-checkout").click(function () {

              if ($(this).is('#lock-group-order')) {
                $(document).foundation();
                $('#confirm-lock-order').foundation('close');

                lockGroupOrder(lockOrder = true);
              }
              participantCheckout = false;

              if ($(this).is('.participant-checkout')) {
                participantCheckout = true;
              }
              // if ($(this).is('[data-group-order-hide-if-not-participant]')) {
              //   console.log('asdgsadg');
              // }
              var cartItems = [];
              $(
                "[data-cart-product-selections] .cart-product:not(.hide) .remove-item"
              ).each(function () {
                var productId = Number($(this).attr("data-product-id"));
                var productName = $(this).attr("data-product-name");
                var productPrice = $(this).attr("data-product-price");
                var productVariant = $(this).attr("data-product-variant");
                var productQuantity = Number($(this).attr("data-product-qty"));

                cartItems.push({
                  item_id: productId,
                  item_name: productName,
                  affiliation: localStorage.getItem(
                    "ecw_customer_store_location_name"
                  ),
                  price: productPrice,
                  item_variant: productVariant,
                  quantity: productQuantity,
                });
              });

              // GA4 open shopping cart
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              var ga4Data = {
                event: "begin_checkout",
                ecommerce: {
                  currency: "USD",
                  // 'value': Number($('[data-cart-grand-total]').attr('data-cart-grand-total')),
                  value: Number(
                    $("[data-cart-subtotal]").attr("data-cart-subtotal")
                  ),
                  items: cartItems,
                },
              };
              const hasExtraCookieConsent = checkNonNecessaryConsent();
              if (hasExtraCookieConsent) {
                // console.log("GA4: ", ga4Data);
                window.dataLayer.push(ga4Data);
              }


              // Close Cart
              // console.log('not view cart!');
              // not_view_cart();
              // $("#shopping-cart-view").foundation("close");
              // if (!localStorage.getItem("ecw_confirm_location")) {

              if (!localStorage.getItem("ecw_confirm_location")) {
                initMap();

                $(document).foundation();
                $('#confirm-store-location').foundation('open');

                //
                $backBtn = $("#confirm-store-location [data-back-button]");
                $backBtn.click(function () {
                  localStorage.removeItem('ecw_confirm_location');
                  localStorage.removeItem('ecw_visitor_store_latitude');
                  localStorage.removeItem('ecw_visitor_store_longitude');
                  change_view('start-order');
                  $('#confirm-store-location').foundation('close');

                });

                $('#confirm-store-location').on('closed.zf.reveal', function () {
                  localStorage.setItem('ecw_confirm_location', 'true');
                });
              }

              if (localStorage.getItem("ecw_access_token") || participantCheckout) {
                // Go to checkout

                // console.log('view checkout');
                change_view("checkout");
              } else {
                // console.log('view login');

                change_view('login', noHashChange = true);
                // Display login prompt
                displaySignInForm();
                //$('#login-rewards-prompt-view').foundation('open');
              }
            });

            $("#rewards-signup").click(displaySignUpForm);
            $('button#register-card-signup').off('click').on('click', function () {
              // view_cart();
              // console.log('i click');
              change_view('register-card');
            });
          } else {
            $(".cart-checkout").off("click");

            if (window.location.hash == "#checkout") {
              change_view("menu");
            }
          } // if(result.products.length)

          setPaymentSplit();

          // Update Applied Reward List
          if (result.appliedrewards.length) {
            updateRewardsList(result.appliedrewards, [
              result.appliedrewards[0].reference,
            ]);
          } else {
            $.when(olo_get_qualifying_rewards()).done(function (
              qual_rewards_json
            ) {
              // console.log(qual_rewards_json);
              var qual_rewards = JSON.parse(qual_rewards_json);

              updateRewardsList(qual_rewards.rewards);
            });
          }

          // Clear displayed coupons
          $(
            "[data-coupon-apply-list] [data-coupon-apply-template]:not(.hide)"
          ).remove();
          $("[data-coupon-description]").addClass("hide");

          // testing coupon display
          // result.coupon = {
          //   "couponcode": "Take20",
          //   "description": "Take 20% off order"
          // };

          // Display Coupons
          if (result.coupon) {
            var $couponItem = $(
              "[data-coupon-apply-list] [data-coupon-apply-template].hide"
            ).clone();
            var $couponDescription = $("[data-coupon-description]");
            var $couponTitle = $("[data-coupon-title]");

            $couponItem.attr(
              "aria-label",
              "Click to Remove Coupon: " + result.coupon.couponcode
            );
            $couponTitle.text(result.coupon.couponcode + " Coupon");
            $couponItem.attr("data-remove-coupon", result.coupon.couponcode);
            $couponItem.html("<span>Remove</span>");
            $couponDescription.text(result.coupon.description);
            $couponDescription.removeClass("hide");

            // $couponItem.text(
            //   "Coupon: " +
            //     result.coupon.couponcode +
            //     " - " +
            //     result.coupon.description
            // );

            $couponItem.removeClass("hide");

            $("[data-coupon-apply-list]").append($couponItem);
            $("[data-coupon-apply-list]").removeClass("hide");
            $("[data-coupon-code-entry]").addClass("hide");

            $couponItem.click(function () {
              // Remove Coupon
              ecw_show_loading();
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_remove_coupon_from_basket",
                  basketGuid: localStorage.getItem(
                    "ecw_customer_basket_id"
                  ),
                  referer: window.location.href

                },
                success: function (response) {
                  // console.log(response);
                },
                complete: function () {
                  ecw_hide_loading();
                  console.log('update basket test #12');

                  updateBasketDisplay();
                },
              });
            });
          } else {
            $("[data-coupon-apply-list]").addClass("hide");
            $("[data-coupon-code-entry]").removeClass("hide");
          }
        } else {
          $("[data-location-order-details]").addClass("hide");
          $("[data-add-another-menu-item]").addClass("hide");
          $("[data-start-a-new-order]").removeClass("hide");

          $("[data-delivery-mode]").text("");
          $("[data-timemode]").text("");
          $("[data-leadtimeestimateminutes]").text("");

          clearBasketSession();
        }
        // ecw_hide_loading();
      },
      complete: function () {
        if (openBasket) {
          // view_cart();
          change_view('cart');
        } else {
          // console.log('not view cart!');
          // console.log('not view cart!');

          not_view_cart();
        }

        ecw_hide_loading();
      },
    });
  } else {
    // No cart
    $(".shopping-cart-icon [data-counter]").text(0);

    // reset basket
    $("[data-cart-empty]").removeClass("hide");
    $(
      "[data-cart-product-template]:not(.hide), [data-tax-row-template]:not(.hide)"
    ).each(function () {
      $(this).remove();
    });
    $("[data-cart-upsell-items]").addClass("hide");
    $("[data-cart-totals]").addClass("hide");
    $(".shopping-cart-icon [data-counter]").addClass("hide");

    ecw_hide_loading();
  }
} // updateBasketDisplay()

function updateRewardsList(rewards, applied_rewards = []) {
  var $ = jQuery;

  // console.log(rewards, applied_rewards);
  if (localStorage.getItem("ecw_customer_grouporderGuid") && localStorage.getItem("ecw_customer_group_order_user_type") === "host") {
    $('.order-summary').removeClass('participant');

    $('[data-group-order-info]').removeClass('hide');
    $('[data-checkout-stuff]').removeClass('hide');

    $('[ata-group-participant-order-info]').addClass('hide');
    $('[data-rewards-info]').addClass('hide');
    $('[data-not-rewards-info]').addClass('hide');
  } else if (localStorage.getItem("ecw_customer_group_order_user_type")) {
    $('.order-summary').addClass('participant');
    $('[data-group-participant-order-info]').removeClass('hide');
    $('[data-checkout-stuff]').addClass('hide');
    $('[data-group-order-info]').addClass('hide');
    $('[data-rewards-info]').addClass('hide');
    $('[data-not-rewards-info]').addClass('hide');

    const groupOrderName = localStorage.getItem('ecw_customer_host_group_order_name');
    if (groupOrderName) {
      const uppercaseName = groupOrderName.toUpperCase();
      $('[data-group-order-name]').text(uppercaseName + "'S ");
    }
    $('[data-customer-group-order-name]').text(localStorage.getItem("ecw_customer_group_order_name"));
  }
  else if (localStorage.getItem("ecw_customer_signed_in") && localStorage.getItem("ecw_access_token") && localStorage.getItem("ecw_auth_token")) {
    $('.order-summary').removeClass('participant');

    $('[data-rewards-info]').removeClass('hide');
    $('[data-checkout-stuff]').removeClass('hide');

    $('[ata-group-participant-order-info]').addClass('hide');
    $('[data-not-rewards-info]').addClass('hide');
    $('[data-group-order-info]').addClass('hide');

  } else {
    $('.order-summary').removeClass('participant');
    $('[data-rewards-info]').addClass('hide');
    $('[data-checkout-stuff]').removeClass('hide');

    $('[ata-group-participant-order-info]').addClass('hide');
    $('[data-not-rewards-info]').removeClass('hide');
    $('[data-group-order-info]').addClass('hide');
  }
  var $rewards_list = $("[data-reward-item-list]");
  var $rewards_list_cart = $("[data-reward-item-list-cart]");

  // Remove any listed rewards
  $rewards_list.find("[data-reward-item-template]:not(.hide)").remove();
  $rewards_list_cart.find("[data-reward-item-template]:not(.hide)").remove();

  if (typeof rewards === "undefined") {
    $("[data-rewards-container]").addClass("hide");
    $("[data-rewards-upsell]").removeClass("hide");
    $("[data-reward-messaging]").addClass("hide");
  } else {
    $("[data-rewards-container]").removeClass("hide");
    $("[data-rewards-upsell]").addClass("hide");
    $("[data-reward-messaging]").removeClass("hide");

  }

  // List rewards
  if (rewards && rewards.length) {
    // Display rewards
    $("[data-reward-not-found]").addClass("hide");
    $rewards_list.removeClass("hide");
    $rewards_list_cart.removeClass("hide");

    $.each(rewards, function (key, reward) {
      var $reward_template = $("[data-reward-item-template].hide").clone();

      $reward_template
        .find("input")
        .attr("id", reward.rewardid + "_" + reward.reference);
      $reward_template.find("input").attr("data-reference", reward.reference);
      $reward_template.find("input").attr("data-rewardid", reward.rewardid);
      $reward_template
        .find("label")
        .attr("for", reward.rewardid + "_" + reward.reference);

      var quanityAvailable = reward.quantityavailable + " ";
      if (quanityAvailable < 2) {
        quanityAvailable = "";
      }
      $reward_template
        .find("label .title")
        .text(quanityAvailable + reward.label);
      $reward_template
        .find("p .title")
        .text(quanityAvailable + reward.label);
      $reward_template.find("label .description").text(reward.fineprint);

      if (applied_rewards.includes(reward.reference)) {
        $reward_template.find("input").prop("checked", true);
      }
      if (reward.quantityavailable === 0) {
        $reward_template.find('input').addClass('hide');
        $reward_template.find('label').addClass('hide');
        $reward_template.find('p').removeClass('hide').addClass('asfasf');
      } else {

      }
      $reward_template.removeClass("hide");
      $rewards_list.append($reward_template);
      // for Cart
      $reward_template_cart = $reward_template.clone();
      $reward_template_cart
        .find("input")
        .attr("id", reward.rewardid + "_" + reward.reference + "_cart");
      $reward_template_cart
        .find("label")
        .attr("for", reward.rewardid + "_" + reward.reference + "_cart");
      $rewards_list_cart.append($reward_template_cart);
    });

    // Select Reward
    $rewards_list.find('input[name="reward-selector"]').change(rewardChange);
    $rewards_list_cart
      .find('input[name="reward-selector"]')
      .change(rewardChange);

    function rewardChange() {
      ecw_show_loading();

      // var $selectedReward = $("[data-reward-item-list]").find('input[name="reward-selector"]:checked');
      // var $selectedRewardCart = $("[data-reward-item-list-cart]").find('input[name="reward-selector"]:checked');

      var $isSelected = $(this).prop("checked");

      // console.log($isSelected, $(this).attr("data-reference"));

      if ($isSelected) {
        // apply Reward
        $.when(olo_add_reward_to_basket($(this).attr("data-reference"))).done(
          function (reward_json) {
            // console.log(reward_json);
            var reward = JSON.parse(reward_json);
            if ("code" in reward) {
              // display Error
              // console.log('rewards', reward);
              // reset reward boxes
              $('input[name="reward-selector"]').each(function () {
                $(this).prop("checked", false);
              });
            } else {
              // console.log('rewards applied', reward);

              // Reward Applied.
            }
            // $.when(olo_validate_basket()).done(function (validate_json) {
            //   ecw_hide_loading();
            console.log('update basket test #13');

            updateBasketDisplay();
            // });
          }
        );
      } else {
        // Remove Reward
        var applied_reward_ids = [$(this).attr("data-rewardid")];

        if (applied_reward_ids.length) {
          $.when(olo_remove_reward_to_basket(applied_reward_ids[0])).done(
            function (remove_reward_json) {
              // console.log(remove_reward_json);
              // $.when(olo_validate_basket()).done(function (validate_json) {
              //   ecw_hide_loading();
              console.log('update basket test #14');

              updateBasketDisplay();
              // });
            }
          );
        }
      }
    }
  } else {
    // No rewards Available
    $("[data-reward-not-found]").removeClass("hide");
    $rewards_list.addClass("hide");
    $rewards_list_cart.addClass("hide");
  }
}

function olo_add_upsell_items(itemid, quantity) {
  var $ = jQuery;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  var itemPrice = Number(
    $(
      'button[data-add-upsell-to-cart][data-item-id="' +
      itemid +
      '"] .product-details [data-price]'
    )
      .first()
      .text()
      .replace("$ ", "")
      .replace("/ea.", "")
  );
  var addToCartData = {
    event: "add_to_cart",
    ecommerce: {
      currency: "USD",
      value: itemPrice,
      items: [
        {
          item_id: itemid,
          item_name: $(
            'button[data-add-upsell-to-cart][data-item-id="' +
            itemid +
            '"] .product-details [data-product-title]'
          )
            .first()
            .text(),
          affiliation: localStorage.getItem(
            "ecw_customer_store_location_name"
          ),
          price: itemPrice,
          item_variant: "Upsell",
          quantity: quantity,
        },
      ],
    },
  };
  const hasExtraCookieConsent = checkNonNecessaryConsent();
  if (hasExtraCookieConsent) {
    // console.log("GA4:", addToCartData);
    window.dataLayer.push(addToCartData);

  }

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_add_upsell_items",
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      itemid: itemid,
      quantity: quantity,
      referer: window.location.href
    },
    success: function (response) { },
    complete: function () { },
  });
}

function olo_create_basket(vendorid, supportsbaskettransfers, reset = false) {
  var $ = jQuery;
  // console.log('olo_create_basket', vendorid, supportsbaskettransfers, reset);

  var existingbasketguid = localStorage.getItem("ecw_customer_basket_id");
  var existingvendorid = localStorage.getItem(
    "ecw_customer_store_location_id"
  );

  console.log("New: " + vendorid, "Existing: " + existingvendorid);
  // Freshen Store Info
  // localStorage.setItem('ecw_customer_location_name', $(this).attr('data-location-name'));
  // localStorage.setItem('ecw_customer_location_address', $(this).attr('data-location-address'));
  // localStorage.setItem('ecw_customer_location_city_zip', $(this).attr('data-location-city-zip'));

  // if ( 
  //   existingbasketguid &&
  //   existingvendorid !== vendorid &&
  //   supportsbaskettransfers
  // ) {
  if (
    existingbasketguid && existingvendorid == vendorid && !reset
  ) {
    // If basket exists but store has changed, transfer basket to new store.
    console.log("Transfer Basket");

    localStorage.setItem("ecw_customer_store_location_id", vendorid);

    $.when(olo_get_restaurant(vendorid)).done(function (restaurant_json) {
      var restaurant = JSON.parse(restaurant_json);
      localStorage.setItem(
        "ecw_customer_store_location_name",
        restaurant.name
      );
      hideFakeMenuIfAddedLocation();

    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_transfer_basket",
        basketGuid: localStorage.getItem("ecw_customer_basket_id"),
        vendorid: vendorid,
        referer: window.location.href,
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
        //
        // if(result.id) {
        //   return result.id;
        // }
        var result = JSON.parse(response);

        // Pick up new Basket ID
        if (result.basket.id) {
          localStorage.setItem("ecw_customer_basket_id", result.basket.id);
          console.log('transfer backet to', vendorid);

          updateBasketDisplay();
          return result.basket.id;
        }
      },
      complete: function () { },
    });
  }
  // else if (existingbasketguid && existingvendorid == vendorid && !reset) {
  //   // if basket and store match session values, return basket
  //   // console.log("Basket Exists and Matches Current Vendor, return existing");

  //   return $.ajax({
  //     type: "POST",
  //     url: ajax_url,
  //     data: {
  //       action: "olo_get_basket",
  //       basketGuid: localStorage.getItem("ecw_customer_basket_id"),
  //       referer: window.location.href,

  //     },
  //     success: function (response) {
  //       // console.log(response);
  //       // console.log(JSON.parse(response));
  //       var result = JSON.parse(response);
  //       // console.log('olo_get_basket', result);
  //       //
  //       // if(result.id) {
  //       //   return result.id;
  //       // }
  //     },
  //     complete: function () { },
  //   });
  // } 
  else {
    // Create fresh basket
    // console.log("Create a fresh basket");
    localStorage.setItem("ecw_customer_store_location_id", vendorid);

    $.when(olo_get_restaurant(vendorid)).done(function (restaurant_json) {
      var restaurant = JSON.parse(restaurant_json);
      localStorage.setItem(
        "ecw_customer_store_location_name",
        restaurant.name
      );
      hideFakeMenuIfAddedLocation();
    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_create_basket",
        vendorid: vendorid,
        referer: window.location.href,

      },
      success: function (response) {
        // console.log(response);
        // console.log('olo_create_basket', JSON.parse(response));
        var result = JSON.parse(response);

        if (result.id) {
          localStorage.setItem("ecw_customer_basket_id", result.id);
          // console.log('update basket test #16');

          updateBasketDisplay();
          return result.id;
        }
      },
      complete: function () { },
    });
  }
}

function olo_check_delivery_coverage(restaurants, view_context) {
  var $ = jQuery;

  var delivery_details = {
    handoffmode: $(
      'input[name="' + view_context + '-order-type"]:checked'
    ).val(), //$('input[name="order-type"]:checked').val(),
    timewantedmode: $(
      'input[name="' + view_context + '-order-schedule"]:checked'
    ).val(),
    street: $(
      "#" + view_context + "-order-location-search-streetaddress"
    ).val(),
    city: $("#" + view_context + "-order-location-search-city").val(),
    zipcode: $("#" + view_context + "-order-location-search-zipcode").val(),
  };

  if (delivery_details.timewantedmode !== "asap") {
    delivery_details.timewantedutc =
      $("#" + view_context + "-time-wanted-day")
        .val()
        .replace(/-/g, "") +
      " " +
      $("#" + view_context + "-time-wanted-time-slot").val(); // yyyymmdd hh:mm
  }

  // console.log("delivery_details", delivery_details);

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_check_delivery_coverage",
      restaurants: restaurants,
      delivery_details: delivery_details,
      referer: window.location.href,
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_get_restaurant(vendorid, getCalendar = false) {
  var $ = jQuery;

  // console.log('vendorid', vendorid);
  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_restaurant",
      restaurant_id: vendorid,
      get_calendar: getCalendar,
      referer: window.location.href
    },
    success: function (response) {
      // console.log(response);
      // console.log('olo_get_restaurant', JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_set_basket_settings(
  view_context,
  earliestReadyTime = "",
  leadtimeminutes = 0
) {
  var $ = jQuery;

  var scheduleDate = "";
  var scheduleTime = "";

  if ($("#" + view_context + "-time-wanted-day").val()) {
    scheduleDate = $("#" + view_context + "-time-wanted-day")
      .val()
      .split("-");
  }
  if ($("#" + view_context + "-time-wanted-time-slot").val()) {
    scheduleTime = $("#" + view_context + "-time-wanted-time-slot")
      .val()
      .split(":");
  }

  // Set Handoff /baskets/{basketGuid}/deliverymode
  // Set Delivery Address /baskets/{basketGuid}/deliveryaddress
  // Set Time Wanted (schedule) /baskets/{basketGuid}/timewanted

  var deliverymode = $(
    'input[name="' + view_context + '-order-type"]:checked'
  ).val();

  var apiData = {
    action: "olo_set_basket_settings",
    basketGuid: localStorage.getItem("ecw_customer_basket_id"),
    // deliverymode: $('input[name="order-type"]:checked').val(),
    deliverymode: deliverymode,
    deliveryaddress: {
      streetaddress: $(
        "#" + view_context + "-order-location-search-streetaddress"
      ).val(),
      city: $("#" + view_context + "-order-location-search-city").val(),
      zipcode: $("#" + view_context + "-order-location-search-zipcode").val(),
      // building: $("#" + view_context + "-order-location-search-building").val(),
    },
    schedule: $(
      'input[name="' + view_context + '-order-schedule"]:checked'
    ).val(),
    referer: window.location.href,
  };
  // console.log('olo_set_basket_settings apiData', apiData);
  if (apiData.schedule !== "asap") {
    apiData.timewanted = {
      ismanualfire: false,
      year: scheduleDate[0],
      month: scheduleDate[1],
      day: scheduleDate[2],
      hour: scheduleTime[0],
      minute: scheduleTime[1],
    };
  } else {
    apiData.timewanted = {};
    // Determine earliest available time
    var d = new Date(),
      currentTime =
        [
          d.getFullYear(),
          (d.getMonth() + 1).padLeft(),
          d.getDate().padLeft(),
        ].join("") +
        " " +
        [d.getHours().padLeft(), d.getMinutes().padLeft()].join(":");
  }

  // console.log('apiData', apiData, ajax_url);

  // console.log(apiData);

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: apiData,
    success: function (response) {
      // console.log(response);
      // console.log('apiData response', JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_set_delivery_instructions() {
  var $ = jQuery;
  if (localStorage.getItem("ecw_customer_deliverymode") == "dispatch") {
    var apiData = {
      action: "olo_set_delivery_instructions",
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      deliveryaddress: {
        streetaddress: localStorage.getItem(
          "ecw_customer_address_streetaddress"
        ),
        city: localStorage.getItem("ecw_customer_address_city"),
        zipcode: localStorage.getItem("ecw_customer_address_zipcode"),
        building: localStorage.getItem("ecw_customer_address_building"),
        phonenumber: $("[data-customer-phone]").text().replace(/\D/g, ""),
        specialinstructions: $("#checkout-delivery-instructions").val(),
      },
      referer: window.location.href,

    };

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: apiData,
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_set_custom_fields() {
  var $ = jQuery;
  if (
    $("[data-custom-fields-info]:not(.hide)").length &&
    $("[data-custom-field-template]:not(.hide)").length
  ) {
    var apiData = {
      action: "olo_set_custom_fields",
      basketGuid: localStorage.getItem("ecw_customer_basket_id"),
      customFields: [],
      referer: window.location.href,

    };

    $("[data-custom-field-template]:not(.hide)").each(function () {
      apiData.customFields.push({
        id: $(this).find("input").attr("data-custom-field-id"),
        value: $(this).find("input").val(),
      });
    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: apiData,
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

// function olo_create_basket(vendorid) {
//   var $ = jQuery;
//
//   ecw_show_loading();
//
//   var deliveryaddress = {};
//
//   if(deliverymode == 'delivery') {
//     deliveryaddress = {
//       building: '',
//       streetaddress: '',
//       city: '',
//       zipcode: ''
//     };
//   }
//
//   // Create Basket /baskets/create
//   $.ajax({
//     type: 'POST',
//     url: ajax_url,
//     data: {
//       action : 'olo_create_basket',
//       vendorid : vendorid,
//       authtoken: localStorage.getItem('ecw_auth_token'),
//       deliverymode: deliverymode,
//       deliveryaddress: deliveryaddress
//     },
//     success: function(response) {
//       console.log(response);
//       var result = JSON.parse(response);
//       if(result.status == "success") {
//
//       }
//     },
//     complete: function() {
//       ecw_hide_loading();
//     }
//   });
//
//   // Set Handoff /baskets/{basketGuid}/deliverymode
//
//   // Set Delivery Address /baskets/{basketGuid}/deliveryaddress
//
//   // Set Time Wanted (schedule) /baskets/{basketGuid}/timewanted
// }

function ecw_show_loading() {
  var $ = jQuery;
  $(".wf-ordering-loading:not(.overloader)").removeClass("hide");
  // console.log("show loader");
}

function ecw_hide_loading() {
  var $ = jQuery;
  setTimeout(function () {
    $(".wf-ordering-loading:not(.overloader)").addClass("hide");
    // console.log("hide loader");
  }, 250);
}
// A Loader to end all loaders - no function to hide it, so use it only if waiting on a page reload
function ecw_show_overloading() {
  // console.log('show overloader')
  var $ = jQuery;
  var $newloader = $(".wf-ordering-loading").clone();
  $newloader.addClass("overloader");
  $("body").append($newloader);
  $newloader.removeClass("hide");
}
function ecw_hide_overloading() {
  var $ = jQuery;
  var $newloader = $(".wf-ordering-loading");
  // Add the 'hide' class to all matching elements
  setTimeout(function () {
    $newloader.each(function () {
      $(this).addClass("hide");
    });
  }, 250);
}
function ecw_show_topnav() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav").removeClass("hide");
}

function ecw_hide_topnav() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav").addClass("hide");
}

function ecw_show_topnav_location() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav .fa-location-dot").removeClass("hide");
}

function ecw_hide_topnav_location() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav .fa-location-dot").addClass("hide");
}

function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

function getDates(startDate, stopDate) {
  var dateArray = new Array();
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate));
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

function zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

function createQuarterHourIntervals() {
  var earliestToday = new Date();
  earliestToday.setHours(0, 0, 0, 0);
  var from = roundToNearest15(earliestToday);
  var until = from.addDays(1);

  var max = (Math.abs(until - from) / (60 * 60 * 1000)) * 4;
  var time = new Date(from);
  var intervals = []; // more clear name than hours

  // console.log(max);

  for (var i = 0; i < max; i++) {
    intervals.push(formatAMPM(time));
    time.setMinutes(time.getMinutes() + 15);
  }
  return intervals;
}

function roundToNearest15(date = new Date()) {
  const minutes = 15;
  const ms = 1000 * 60 * minutes;

  return new Date(Math.ceil(date.getTime() / ms) * ms);
}

function convert12to24Hour(time) {
  var hours = Number(time.match(/^(\d+)/)[1]);
  var minutes = Number(time.match(/:(\d+)/)[1]);
  var AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM == "pm" && hours < 12) hours = hours + 12;
  if (AMPM == "am" && hours == 12) hours = hours - 12;
  var sHours = hours.toString();
  var sMinutes = minutes.toString();
  if (hours < 10) sHours = "0" + sHours;
  if (minutes < 10) sMinutes = "0" + sMinutes;
  return sHours + ":" + sMinutes;
}

function setQuantityElem($elem, min, max, step) {
  var $input = $elem.find("input.qtyinput");
  var $btnMinus = $elem.find(".qtyminus");
  var $btnPlus = $elem.find(".qtyplus");

  min = Number(min);
  max = Number(max);
  step = Number(step);

  if (min < 1) {
    min = 1;
  }

  if ($input.length && $btnMinus.length && $btnPlus.length) {
    $input.val(min);

    $input.attr("min", min);
    $input.attr("max", max);
    $input.attr("step", step);

    function qtyminus(e) {
      var current = Number($input.val());
      var newval = current - step;
      if (newval < min) {
        newval = min;
      } else if (newval > max) {
        newval = max;
      }
      $input.val(Number(newval));
      $input.trigger("change");
      // console.log('asdgasdgdsg');
      calculateProductTotal();


      e.preventDefault();
    }

    function qtyplus(e) {
      var current = Number($input.val());
      var newval = current + step;;
      // console.log('newval', newval);
      if (newval > max) newval = max;
      $input.val(Number(newval));
      $input.trigger("change");
      // console.log('asdgasdgdsg');
      calculateProductTotal();

      // console.log('newval',  Numb er(jQuery("input#product-item-qty").val()));

      e.preventDefault();
    }

    $btnMinus.off("click");
    $btnPlus.off("click");

    $btnMinus.click(qtyminus);
    $btnPlus.click(qtyplus);
  }
}
